// import React, { useEffect, useMemo, useRef, useState } from "react";

// import AdminSidebar from "./AdminSidebar";
// import AdminTopbar from "./Admintopbar";

// import {
//   getAdminExams,
//   getSections,
//   updateSection,
//   getAdminQuestions,
//   updateAdminQuestion,
//   deleteAdminQuestion,
//   bulkDeleteAdminQuestions,
//   getQuestionDocuments,
//   updateQuestionDocument,
//   deleteQuestionDocument,
//   uploadQuestionBankPdf,
// } from "../api/adminclient";

// import { apiErrorMessage } from "../api/auth";

// /* =========================================================
//    Question Bank — Admin Panel

//    Django-connected version.

//    The existing UI/design is preserved, but the data now comes
//    from the Django admin APIs.

//    PDF upload continues to use the existing Django parser/importer:
//        POST /api/exams/upload/

//    Reprocess functionality has intentionally been removed.
//    ========================================================= */

// const PAGE_SIZE = 5;

// function StatusPill({ status }) {
//   const cls =
//     status === "Active"
//       ? "active"
//       : status === "Inactive"
//         ? "inactive"
//         : "pending";

//   return (
//     <span className={`admin-status-pill ${cls}`}>
//       {status}
//     </span>
//   );
// }

// function IconBtn({
//   variant = "primary",
//   icon,
//   children,
//   onClick,
//   title,
//   disabled = false,
// }) {
//   return (
//     <button
//       type="button"
//       className={`qb-btn-soft-${variant} btn btn-sm d-inline-flex align-items-center gap-1`}
//       onClick={onClick}
//       title={title}
//       disabled={disabled}
//     >
//       <i className={`bi ${icon}`} />
//       {children}
//     </button>
//   );
// }

// function formatDate(value) {
//   if (!value) return "—";

//   const date = new Date(value);

//   if (Number.isNaN(date.getTime())) {
//     return String(value);
//   }

//   return date.toLocaleDateString("en-IN", {
//     day: "2-digit",
//     month: "short",
//     year: "numeric",
//   });
// }

// function normalizeQuestion(question) {
//   return {
//     ...question,
//     text: question.question_text || question.questionText || "",
//     status:
//       question.status ||
//       (question.is_active === false ? "Inactive" : "Active"),
//     chapter:
//       question.answer_data?.chapter ||
//       question.answer_data?.Chapter ||
//       "—",
//   };
// }

// function normalizeDocument(document) {
//   return {
//     ...document,
//     name:
//       document.fileName ||
//       document.file_name ||
//       document.title ||
//       "Question Bank PDF",
//     uploadedOn: formatDate(
//       document.uploadedAt ||
//       document.uploaded_at ||
//       document.created_at ||
//       document.createdAt
//     ),
//     extracted: Number(
//       document.questionsExtracted ??
//       document.questions_extracted ??
//       document.extracted_questions_count ??
//       document.question_count ??
//       0
//     ),
//     selectionCount: Number(
//       document.selectionCount ??
//       document.selection_count ??
//       0
//     ),
//     marksPerQuestion: Number(
//       document.marksPerQuestion ??
//       document.marks_per_question ??
//       0
//     ),
//     pdfFile:
//       document.pdfFile ||
//       document.pdf_file ||
//       document.file ||
//       document.file_url ||
//       "",
//     status:
//       document.processingStatus ||
//       document.processing_status ||
//       document.status ||
//       "Pending",
//   };
// }

// function getSectionType(section) {
//   const type = String(section?.type || "").toUpperCase();

//   if (type.includes("ESSAY")) {
//     return "essay";
//   }

//   return "mcq";
// }

// export default function QuestionBank() {
//   const [exams, setExams] = useState([]);
//   const [sections, setSections] = useState([]);

//   const [selectedExamId, setSelectedExamId] = useState("");
//   const [activeTab, setActiveTab] = useState("mcq");

//   const [questions, setQuestions] = useState([]);
//   const [documents, setDocuments] = useState([]);
//   const [pdfAllocationDrafts, setPdfAllocationDrafts] = useState({});
//   const [savingPdfAllocationId, setSavingPdfAllocationId] = useState(null);
//   const [pdfMarksDrafts, setPdfMarksDrafts] = useState({});
// const [savingPdfMarksId, setSavingPdfMarksId] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [questionsLoading, setQuestionsLoading] = useState(false);
//   const [documentsLoading, setDocumentsLoading] = useState(false);

//   const [error, setError] = useState("");
//   const [actionError, setActionError] = useState("");

//   const [search, setSearch] = useState("");
//   const [chapter, setChapter] = useState("All");
//   const [status, setStatus] = useState("All");

//   const [page, setPage] = useState(1);
//   const [selectedQuestions, setSelectedQuestions] = useState([]);
//   const [bulkMenuOpen, setBulkMenuOpen] = useState(false);

//   const [configOpen, setConfigOpen] = useState(true);

//   const [sectionName, setSectionName] = useState("");
//   const [marksPerQuestion, setMarksPerQuestion] = useState("");
//   const [duration, setDuration] = useState("");

//   const [savingSection, setSavingSection] = useState(false);

//   const [uploading, setUploading] = useState(false);
//   const [uploadTitle, setUploadTitle] = useState("");

//   const uploadInputRef = useRef(null);

//   /* =========================================================
//      Load exams
//      ========================================================= */

//   useEffect(() => {
//     let mounted = true;

//     async function loadExams() {
//       setLoading(true);
//       setError("");

//       try {
//         const response = await getAdminExams();

//         if (!mounted) return;

//         const data = Array.isArray(response.data)
//           ? response.data
//           : response.data?.results || [];

//         setExams(data);

//         if (data.length > 0) {
//           setSelectedExamId(data[0].id);
//         }
//       } catch (err) {
//         if (mounted) {
//           setError(
//             apiErrorMessage(
//               err,
//               "Could not load exams."
//             )
//           );
//         }
//       } finally {
//         if (mounted) {
//           setLoading(false);
//         }
//       }
//     }

//     loadExams();

//     return () => {
//       mounted = false;
//     };
//   }, []);

//   /* =========================================================
//      Load sections whenever exam changes
//      ========================================================= */

//   useEffect(() => {
//     let mounted = true;

//     async function loadSections() {
//       if (!selectedExamId) {
//         setSections([]);
//         return;
//       }

//       setLoading(true);
//       setError("");

//       try {
//         const response = await getSections(selectedExamId);

//         if (!mounted) return;

//         const data = Array.isArray(response.data)
//           ? response.data
//           : response.data?.results || [];

//         setSections(data);

//         const firstMcq = data.find(
//           (section) => getSectionType(section) === "mcq"
//         );

//         const firstEssay = data.find(
//           (section) => getSectionType(section) === "essay"
//         );

//         if (activeTab === "mcq" && !firstMcq && firstEssay) {
//           setActiveTab("essay");
//         }

//         if (activeTab === "essay" && !firstEssay && firstMcq) {
//           setActiveTab("mcq");
//         }
//       } catch (err) {
//         if (mounted) {
//           setError(
//             apiErrorMessage(
//               err,
//               "Could not load exam sections."
//             )
//           );
//         }
//       } finally {
//         if (mounted) {
//           setLoading(false);
//         }
//       }
//     }

//     loadSections();

//     return () => {
//       mounted = false;
//     };
//   }, [selectedExamId]);

//   /* =========================================================
//      Current exam / sections
//      ========================================================= */

//   const currentExam = useMemo(() => {
//     return exams.find(
//       (exam) => String(exam.id) === String(selectedExamId)
//     );
//   }, [exams, selectedExamId]);

//   const mcqSection = useMemo(() => {
//     return sections.find(
//       (section) => getSectionType(section) === "mcq"
//     );
//   }, [sections]);

//   const essaySection = useMemo(() => {
//     return sections.find(
//       (section) => getSectionType(section) === "essay"
//     );
//   }, [sections]);

//   const section = activeTab === "mcq"
//     ? mcqSection
//     : essaySection;

//   /* =========================================================
//      Load questions + PDFs for current section
//      ========================================================= */

//   async function loadQuestionBank(sectionId = section?.id) {
//     if (!sectionId) {
//       setQuestions([]);
//       setDocuments([]);
      
//       return;
//     }

//     setQuestionsLoading(true);
//     setDocumentsLoading(true);
//     setActionError("");

//     try {
//       const [questionResponse, documentResponse] =
//         await Promise.all([
//           getAdminQuestions(sectionId),
//           getQuestionDocuments(sectionId),
//         ]);

//       const questionData = Array.isArray(questionResponse.data)
//         ? questionResponse.data
//         : questionResponse.data?.results || [];

//       const documentData = Array.isArray(documentResponse.data)
//         ? documentResponse.data
//         : documentResponse.data?.results || [];

//       setQuestions(
//         questionData.map(normalizeQuestion)
//       );
      

//       const normalizedDocuments = documentData.map(normalizeDocument);
//       setDocuments(normalizedDocuments);
//       setPdfAllocationDrafts(
//         Object.fromEntries(
//           normalizedDocuments.map((document) => [
//             document.id,
//             String(document.selectionCount ?? 0),
//           ])
//         )
//       );
//       setPdfMarksDrafts(
//         Object.fromEntries(
//           normalizedDocuments.map((document) => [
//             document.id,
//             String(document.marksPerQuestion ?? 0),
//           ])
//         )
//       );
//     } catch (err) {
//       setActionError(
//         apiErrorMessage(
//           err,
//           "Could not load the Question Bank."
//         )
//       );
//     } finally {
//       setQuestionsLoading(false);
//       setDocumentsLoading(false);
//     }
//   }

//   useEffect(() => {
//     setSearch("");
//     setChapter("All");
//     setStatus("All");
//     setPage(1);
//     setSelectedQuestions([]);
//     setBulkMenuOpen(false);

//     if (section?.id) {
//       setSectionName(section.name || "");
//       setMarksPerQuestion(
//         section.marks ?? ""
//       );
//       setDuration(
//         section.durationMinutes ?? ""
//       );

//       loadQuestionBank(section.id);
//     } else {
//       setQuestions([]);
//       setDocuments([]);
//       setSectionName("");
//       setMarksPerQuestion("");
//       setDuration("");
//     }

//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [section?.id]);

//   /* =========================================================
//      Derived values
//      ========================================================= */

//   const filteredQuestions = useMemo(() => {
//     return questions.filter((question) => {
//       const questionText =
//         question.text?.toLowerCase() || "";

//       const matchesSearch =
//         questionText.includes(
//           search.toLowerCase()
//         );

//       /*
//        * Chapter is not a real Question model field.
//        * Only use it if the parser supplied chapter information
//        * inside answer_data.
//        */
//       const matchesChapter =
//         chapter === "All" ||
//         question.chapter === chapter;

//       const matchesStatus =
//         status === "All" ||
//         question.status === status;

//       return (
//         matchesSearch &&
//         matchesChapter &&
//         matchesStatus
//       );
//     });
//   }, [
//     questions,
//     search,
//     chapter,
//     status,
//   ]);

//   const totalPages = Math.max(
//     1,
//     Math.ceil(
//       filteredQuestions.length / PAGE_SIZE
//     )
//   );

//   const visibleQuestions = useMemo(() => {
//     const start =
//       (page - 1) * PAGE_SIZE;

//     return filteredQuestions.slice(
//       start,
//       start + PAGE_SIZE
//     );
//   }, [filteredQuestions, page]);

//   const totalQuestionCount =
//     questions.length;

//   const mcqQuestionCount =
//     mcqSection
//       ? Number(mcqSection.questions || 0)
//       : 0;

//   const essayQuestionCount =
//     essaySection
//       ? Number(essaySection.questions || 0)
//       : 0;

//   const totalConfiguredQuestions =
//     mcqQuestionCount +
//     essayQuestionCount;

//   const startIdx =
//     filteredQuestions.length > 0
//       ? (page - 1) * PAGE_SIZE + 1
//       : 0;

//   const endIdx =
//     filteredQuestions.length > 0
//       ? Math.min(
//           page * PAGE_SIZE,
//           filteredQuestions.length
//         )
//       : 0;

//   const chapters = useMemo(() => {
//     const values = questions
//       .map((question) => question.chapter)
//       .filter(
//         (value) =>
//           value &&
//           value !== "—"
//       );

//     return [
//       "All",
//       ...Array.from(
//         new Set(values)
//       ),
//     ];
//   }, [questions]);

//   /* =========================================================
//      Tab switching
//      ========================================================= */

//   function switchTab(tab) {
//     setActiveTab(tab);
//     setPage(1);
//     setSelectedQuestions([]);
//     setSearch("");
//     setChapter("All");
//     setStatus("All");
//     setBulkMenuOpen(false);
//   }

//   /* =========================================================
//      Selection
//      ========================================================= */

//   function toggleQuestion(id) {
//     setSelectedQuestions((previous) =>
//       previous.includes(id)
//         ? previous.filter(
//             (value) => value !== id
//           )
//         : [...previous, id]
//     );
//   }

//   function toggleAllQuestions() {
//     const visibleIds =
//       visibleQuestions.map(
//         (question) => question.id
//       );

//     const allSelected =
//       visibleIds.length > 0 &&
//       visibleIds.every((id) =>
//         selectedQuestions.includes(id)
//       );

//     if (allSelected) {
//       setSelectedQuestions(
//         (previous) =>
//           previous.filter(
//             (id) =>
//               !visibleIds.includes(id)
//           )
//       );
//     } else {
//       setSelectedQuestions((previous) => [
//         ...new Set([
//           ...previous,
//           ...visibleIds,
//         ]),
//       ]);
//     }
//   }

//   function resetFilters() {
//     setSearch("");
//     setChapter("All");
//     setStatus("All");
//     setPage(1);
//   }

//   /* =========================================================
//      Question status
//      ========================================================= */

//   async function handleToggleQuestionStatus(
//     question
//   ) {
//     setActionError("");

//     try {
//       const newStatus =
//         question.status !== "Active";

//       const response =
//         await updateAdminQuestion(
//           question.id,
//           {
//             is_active: newStatus,
//           }
//         );

//       const updated =
//         normalizeQuestion(response.data);

//       setQuestions((previous) =>
//         previous.map((item) =>
//           item.id === question.id
//             ? updated
//             : item
//         )
//       );
//     } catch (err) {
//       setActionError(
//         apiErrorMessage(
//           err,
//           "Could not update question status."
//         )
//       );
//     }
//   }

//   /* =========================================================
//      Delete individual question
//      ========================================================= */

//   async function handleDeleteQuestion(
//     question
//   ) {
//     const confirmed =
//       window.confirm(
//         "Delete this question permanently?"
//       );

//     if (!confirmed) return;

//     setActionError("");

//     try {
//       await deleteAdminQuestion(
//         question.id
//       );

//       setQuestions((previous) =>
//         previous.filter(
//           (item) =>
//             item.id !== question.id
//         )
//       );

//       setSelectedQuestions((previous) =>
//         previous.filter(
//           (id) =>
//             id !== question.id
//         )
//       );
//     } catch (err) {
//       setActionError(
//         apiErrorMessage(
//           err,
//           "Could not delete question."
//         )
//       );
//     }
//   }

//   /* =========================================================
//      Bulk delete
//      ========================================================= */

//   async function handleBulkDelete() {
//     if (
//       selectedQuestions.length === 0
//     ) {
//       return;
//     }

//     const confirmed =
//       window.confirm(
//         `Delete ${selectedQuestions.length} selected question(s) permanently?`
//       );

//     if (!confirmed) return;

//     setActionError("");

//     try {
//       await bulkDeleteAdminQuestions(
//         selectedQuestions
//       );

//       const selectedSet =
//         new Set(selectedQuestions);

//       setQuestions((previous) =>
//         previous.filter(
//           (question) =>
//             !selectedSet.has(
//               question.id
//             )
//         )
//       );

//       setSelectedQuestions([]);
//       setBulkMenuOpen(false);
//     } catch (err) {
//       setActionError(
//         apiErrorMessage(
//           err,
//           "Could not delete selected questions."
//         )
//       );
//     }
//   }

//   /* =========================================================
//      Bulk activate/deactivate
//      ========================================================= */

//   async function handleBulkStatus(
//     active
//   ) {
//     if (
//       selectedQuestions.length === 0
//     ) {
//       return;
//     }

//     setActionError("");

//     try {
//       await Promise.all(
//         selectedQuestions.map((id) =>
//           updateAdminQuestion(
//             id,
//             {
//               is_active: active,
//             }
//           )
//         )
//       );

//       setQuestions((previous) =>
//         previous.map((question) =>
//           selectedQuestions.includes(
//             question.id
//           )
//             ? {
//                 ...question,
//                 is_active: active,
//                 status: active
//                   ? "Active"
//                   : "Inactive",
//               }
//             : question
//         )
//       );

//       setSelectedQuestions([]);
//       setBulkMenuOpen(false);
//     } catch (err) {
//       setActionError(
//         apiErrorMessage(
//           err,
//           "Could not update selected questions."
//         )
//       );
//     }
//   }

//   /* =========================================================
//      Delete all questions in current section
//      ========================================================= */

//   async function handleDeleteAllQuestions() {
//     if (!section?.id) return;

//     if (questions.length === 0) {
//       return;
//     }

//     const confirmed =
//       window.confirm(
//         `This will permanently delete all ${questions.length} questions currently in this section. Continue?`
//       );

//     if (!confirmed) return;

//     setActionError("");

//     try {
//       const ids =
//         questions.map(
//           (question) => question.id
//         );

//       await bulkDeleteAdminQuestions(ids);

//       setQuestions([]);
//       setSelectedQuestions([]);
//       setPage(1);
//     } catch (err) {
//       setActionError(
//         apiErrorMessage(
//           err,
//           "Could not delete all questions."
//         )
//       );
//     }
//   }

//   /* =========================================================
//      Delete PDF
//      ========================================================= */

//   async function handleDeleteDocument(
//     document
//   ) {
//     const confirmed =
//       window.confirm(
//         `Remove "${document.name}"? Its questions will be deactivated for future exam selection. Existing attempts and their history will be retained.`
//       );

//     if (!confirmed) return;

//     setActionError("");

//     try {
//       await deleteQuestionDocument(
//         document.id
//       );

//       setDocuments((previous) =>
//         previous.filter(
//           (item) =>
//             item.id !== document.id
//         )
//       );
//     } catch (err) {
//       setActionError(
//         apiErrorMessage(
//           err,
//           "Could not delete PDF."
//         )
//       );
//     }
//   }

//   /* =========================================================
//      Save per-PDF question allocation
//      ========================================================= */

//   async function handleSavePdfAllocation(document) {
//     const rawValue =
//       pdfAllocationDrafts[document.id] ??
//       document.selectionCount ??
//       0;
//     const value = Number(rawValue);

//     if (!Number.isInteger(value) || value < 0) {
//       setActionError("PDF allocation must be a non-negative whole number.");
//       return;
//     }

//     if (value > document.extracted) {
//       setActionError(
//         `Allocation cannot exceed the ${document.extracted} questions extracted from this PDF.`
//       );
//       return;
//     }

//     setSavingPdfAllocationId(document.id);
//     setActionError("");

//     try {
//       const response = await updateQuestionDocument(document.id, {
//         selection_count: value,
//       });
//       const updated = normalizeDocument(response.data || {
//         ...document,
//         selection_count: value,
//       });

//       setDocuments((previous) =>
//         previous.map((item) =>
//           String(item.id) === String(document.id) ? updated : item
//         )
//       );
//       setPdfAllocationDrafts((previous) => ({
//         ...previous,
//         [document.id]: String(updated.selectionCount ?? value),
//       }));
//     } catch (err) {
//       setActionError(
//         apiErrorMessage(err, "Could not save this PDF's question allocation.")
//       );
//     } finally {
//       setSavingPdfAllocationId(null);
//     }
//   }

//   /* =========================================================
//      Save per-PDF marks
//      ========================================================= */

//   async function handleSavePdfMarks(document) {
//     const rawValue =
//       pdfMarksDrafts[document.id] ??
//       String(document.marksPerQuestion ?? 0);
//     const value = Number(rawValue);

//     if (
//       rawValue === "" ||
//       !Number.isFinite(value) ||
//       value < 0
//     ) {
//       setActionError("Marks must be a valid non-negative number.");
//       return;
//     }

//     setSavingPdfMarksId(document.id);
//     setActionError("");

//     try {
//       const response = await updateQuestionDocument(document.id, {
//         marks_per_question: value,
//       });

//       const responseData = response?.data || {};
//       const updated = normalizeDocument({
//         ...document,
//         ...responseData,
//         marks_per_question:
//           responseData.marks_per_question ??
//           responseData.marksPerQuestion ??
//           value,
//       });

//       setDocuments((previous) =>
//         previous.map((item) =>
//           String(item.id) === String(document.id) ? updated : item
//         )
//       );

//       setPdfMarksDrafts((previous) => ({
//         ...previous,
//         [document.id]: String(updated.marksPerQuestion),
//       }));
//     } catch (err) {
//       setActionError(
//         apiErrorMessage(err, "Could not save marks for this PDF.")
//       );
//     } finally {
//       setSavingPdfMarksId(null);
//     }
//   }

//   /* =========================================================
//      PDF upload
//      ========================================================= */

//   function openUploadDialog() {
//     if (!section?.id) {
//       setActionError(
//         "Please select a valid exam section first."
//       );
//       return;
//     }

//     setUploadTitle("");
//     uploadInputRef.current?.click();
//   }

//   async function handlePdfSelected(event) {
//     const file =
//       event.target.files?.[0];

//     event.target.value = "";

//     if (!file) return;

//     if (
//       file.type !==
//         "application/pdf" &&
//       !file.name
//         .toLowerCase()
//         .endsWith(".pdf")
//     ) {
//       setActionError(
//         "Please select a PDF file."
//       );
//       return;
//     }

//     if (!section?.id) {
//       setActionError(
//         "No section is selected."
//       );
//       return;
//     }

//     const defaultTitle =
//       file.name.replace(
//         /\.pdf$/i,
//         ""
//       );

//     const title =
//       window.prompt(
//         "Enter a title for this PDF:",
//         defaultTitle
//       );

//     if (title === null) {
//       return;
//     }

//     setUploading(true);
//     setActionError("");

//     try {
//       await uploadQuestionBankPdf({
//         sectionId: section.id,
//         title:
//           title.trim() ||
//           defaultTitle,
//         file,
//       });

//       /*
//        * The parser/importer creates the QuestionBankDocument
//        * and Question records. Reload both after upload.
//        */
//       await loadQuestionBank(
//         section.id
//       );

//       /*
//        * Reload sections too because the parser/importer may
//        * change the number of questions available for the
//        * section.
//        */
//       const response =
//         await getSections(
//           selectedExamId
//         );

//       const sectionData =
//         Array.isArray(response.data)
//           ? response.data
//           : response.data?.results || [];

//       setSections(sectionData);
//     } catch (err) {
//       setActionError(
//         apiErrorMessage(
//           err,
//           "Could not upload and process the PDF."
//         )
//       );
//     } finally {
//       setUploading(false);
//     }
//   }

//   /* =========================================================
//      Save section settings
//      ========================================================= */

//   async function handleSaveSection() {
//     if (!section?.id) return;

//     if (!sectionName.trim()) {
//       setActionError(
//         "Section name is required."
//       );
//       return;
//     }

//     if (
//       marksPerQuestion === "" ||
//       Number(marksPerQuestion) < 0
//     ) {
//       setActionError(
//         "Marks per question must be valid."
//       );
//       return;
//     }

//     if (
//       duration === "" ||
//       Number(duration) < 1
//     ) {
//       setActionError(
//         "Duration must be at least 1 minute."
//       );
//       return;
//     }

//     setSavingSection(true);
//     setActionError("");

//     try {
//       await updateSection(
//         section.id,
//         {
//           name: sectionName.trim(),
//           type: section.type,
//           questions:
//             Number(section.questions) ||
//             Math.max(
//               1,
//               questions.length
//             ),
//           marks:
//             Number(marksPerQuestion),
//           durationMinutes:
//             Number(duration),
//           examId: selectedExamId,
//         }
//       );

//       const response =
//         await getSections(
//           selectedExamId
//         );

//       const data =
//         Array.isArray(response.data)
//           ? response.data
//           : response.data?.results || [];

//       setSections(data);

//       const updatedSection =
//         data.find(
//           (item) =>
//             String(item.id) ===
//             String(section.id)
//         );

//       if (updatedSection) {
//         setSectionName(
//           updatedSection.name || ""
//         );
//         setMarksPerQuestion(
//           updatedSection.marks ?? ""
//         );
//         setDuration(
//           updatedSection.durationMinutes ??
//             ""
//         );
//       }
//     } catch (err) {
//       setActionError(
//         apiErrorMessage(
//           err,
//           "Could not save section settings."
//         )
//       );
//     } finally {
//       setSavingSection(false);
//     }
//   }

//   /* =========================================================
//      Pagination
//      ========================================================= */

//   function getPages() {
//     const pages = [];

//     const end = Math.min(
//       5,
//       totalPages
//     );

//     for (
//       let index = 1;
//       index <= end;
//       index += 1
//     ) {
//       pages.push(index);
//     }

//     if (totalPages > end) {
//       pages.push("ellipsis");
//       pages.push(totalPages);
//     }

//     return pages;
//   }

//   /* =========================================================
//      Render
//      ========================================================= */

//   return (
//     <div className="admin-page-full d-flex">
//       <AdminSidebar />

//       <div className="admin-content">
//         <AdminTopbar
//           notificationCount={3}
//         />

//         {/* Header */}
//         <div className="d-flex justify-content-between align-items-start flex-wrap gap-2 mb-3">
//           <div>
//             <h1 className="h3 fw-bold mb-1">
//               Question Bank
//               {currentExam
//                 ? ` - ${currentExam.name}`
//                 : ""}
//             </h1>

//             <p className="text-muted mb-0">
//               Manage questions for each
//               section. Upload PDFs, view
//               questions, and configure section
//               settings.
//             </p>
//           </div>

//           <div className="d-flex align-items-center gap-2">
//             {exams.length > 1 && (
//               <select
//                 className="form-select"
//                 value={selectedExamId}
//                 onChange={(event) => {
//                   setSelectedExamId(
//                     event.target.value
//                   );
//                   setPage(1);
//                 }}
//                 style={{
//                   minWidth: 190,
//                 }}
//               >
//                 {exams.map((exam) => (
//                   <option
//                     key={exam.id}
//                     value={exam.id}
//                   >
//                     {exam.name}
//                   </option>
//                 ))}
//               </select>
//             )}

//             <button
//               type="button"
//               className="btn btn-outline-secondary d-inline-flex align-items-center gap-2"
//               onClick={() =>
//                 window.history.back()
//               }
//             >
//               <i className="bi bi-arrow-left" />
//               Back to Exam
//             </button>
//           </div>
//         </div>

//         {/* Error */}
//         {(error || actionError) && (
//           <div
//             className="alert alert-danger d-flex align-items-start gap-2"
//             role="alert"
//           >
//             <i className="bi bi-exclamation-triangle mt-1" />

//             <div className="flex-grow-1">
//               {actionError || error}
//             </div>

//             <button
//               type="button"
//               className="btn-close"
//               onClick={() => {
//                 setError("");
//                 setActionError("");
//               }}
//             />
//           </div>
//         )}

//         {loading ? (
//           <div className="admin-card p-5 text-center">
//             <div
//               className="spinner-border text-primary"
//               role="status"
//             />

//             <div className="text-muted mt-3">
//               Loading Question Bank...
//             </div>
//           </div>
//         ) : (
//           <>
//             {/* Summary */}
//             <div className="admin-card qb-summary-card p-3 p-md-4 mb-3">
//               <div className="d-flex flex-wrap align-items-center gap-4">
//                 <div className="d-flex align-items-center gap-3 qb-summary-main">
//                   <div className="qb-summary-icon">
//                     <i className="bi bi-journal-check" />
//                   </div>

//                   <div>
//                     <div className="d-flex align-items-center gap-2 mb-1">
//                       <h2 className="h5 fw-bold mb-0">
//                         {currentExam?.name ||
//                           "Question Bank"}
//                       </h2>

//                       <StatusPill
//                         status={
//                           currentExam?.status ||
//                           "Active"
//                         }
//                       />
//                     </div>

//                     <div className="qb-meta-row text-muted small">
//                       <span>
//                         Course:{" "}
//                         {currentExam?.courseName ||
//                           currentExam?.course ||
//                           "—"}
//                       </span>

//                       <span className="qb-meta-sep">
//                         |
//                       </span>

//                       <span>
//                         Exam Fee:{" "}
//                         {currentExam?.fee != null
//                           ? `₹${Number(
//                               currentExam.fee
//                             ).toLocaleString(
//                               "en-IN"
//                             )}`
//                           : "—"}
//                       </span>

//                       <span className="qb-meta-sep">
//                         |
//                       </span>

//                       <span>
//                         Result Release Delay:{" "}
//                         {currentExam
//                           ?.resultDelayHours !=
//                         null
//                           ? `${currentExam.resultDelayHours} Hours`
//                           : "—"}
//                       </span>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="d-flex flex-wrap gap-4 ms-lg-auto qb-summary-stats">
//                   <div className="qb-mini-stat">
//                     <div className="qb-mini-icon blue">
//                       <i className="bi bi-cloud-arrow-up-fill" />
//                     </div>

//                     <div>
//                       <div className="qb-mini-value">
//                         {totalConfiguredQuestions.toLocaleString()}
//                       </div>

//                       <div className="qb-mini-label">
//                         Total Questions
//                       </div>
//                     </div>
//                   </div>

//                   <div className="qb-mini-stat">
//                     <div className="qb-mini-icon purple">
//                       <i className="bi bi-text-left" />
//                     </div>

//                     <div>
//                       <div className="qb-mini-value">
//                         {mcqQuestionCount.toLocaleString()}
//                       </div>

//                       <div className="qb-mini-label">
//                         MCQ Questions
//                       </div>
//                     </div>
//                   </div>

//                   <div className="qb-mini-stat">
//                     <div className="qb-mini-icon orange">
//                       <i className="bi bi-file-earmark-text" />
//                     </div>

//                     <div>
//                       <div className="qb-mini-value">
//                         {essayQuestionCount.toLocaleString()}
//                       </div>

//                       <div className="qb-mini-label">
//                         Essay Questions
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Tabs */}
//             <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
//               <div className="qb-tabs">
//                 <button
//                   type="button"
//                   className={`qb-tab-btn ${
//                     activeTab === "mcq"
//                       ? "active"
//                       : ""
//                   }`}
//                   onClick={() =>
//                     switchTab("mcq")
//                   }
//                   disabled={!mcqSection}
//                 >
//                   MCQ Section (
//                   {mcqQuestionCount.toLocaleString()}
//                   )
//                 </button>

//                 <button
//                   type="button"
//                   className={`qb-tab-btn ${
//                     activeTab === "essay"
//                       ? "active"
//                       : ""
//                   }`}
//                   onClick={() =>
//                     switchTab("essay")
//                   }
//                   disabled={!essaySection}
//                 >
//                   Essay Section (
//                   {essayQuestionCount.toLocaleString()}
//                   )
//                 </button>
//               </div>

//               <button
//                 type="button"
//                 className="btn btn-outline-secondary d-inline-flex align-items-center gap-2"
//                 onClick={() =>
//                   setConfigOpen(
//                     (value) => !value
//                   )
//                 }
//               >
//                 <i className="bi bi-gear" />
//                 Section Settings
//               </button>
//             </div>

//             {!section ? (
//               <div className="admin-card p-5 text-center">
//                 <i className="bi bi-folder-x fs-1 text-muted" />

//                 <h4 className="h6 fw-bold mt-3">
//                   No {activeTab === "mcq"
//                     ? "MCQ"
//                     : "Essay"} section found
//                 </h4>

//                 <p className="text-muted mb-0">
//                   Create this section from
//                   the Sections admin page
//                   before managing its questions.
//                 </p>
//               </div>
//             ) : (
//               <div className="row g-3 align-items-stretch">
//                 {/* Main content */}
//                 <div
//                   className={
//                     configOpen
//                       ? "col-12 col-xl-8"
//                       : "col-12"
//                   }
//                 >
//                   <div className="admin-card p-3 p-md-4 h-100 d-flex flex-column">
//                     {/* Section header */}
//                     <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
//                       <div className="d-flex align-items-center gap-2">
//                         <div
//                           className="qb-summary-icon"
//                           style={{
//                             width: 40,
//                             height: 40,
//                             fontSize:
//                               "1.05rem",
//                             background:
//                               "var(--oes-blue)",
//                           }}
//                         >
//                           <i className="bi bi-text-left" />
//                         </div>

//                         <div>
//                           <div className="d-flex align-items-center gap-2">
//                             <h3 className="h6 fw-bold mb-0">
//                               {section.name}
//                             </h3>

//                             <StatusPill status="Active" />
//                           </div>

//                           <div className="qb-meta-row text-muted small">
//                             <span>
//                               Marks per Question:{" "}
//                               {section.marks ??
//                                 "—"}
//                             </span>

//                             <span className="qb-meta-sep">
//                               |
//                             </span>

//                             <span>
//                               Total Questions:{" "}
//                               {totalQuestionCount.toLocaleString()}
//                             </span>

//                             <span className="qb-meta-sep">
//                               |
//                             </span>

//                             <span>
//                               PDF Files:{" "}
//                               {documents.length}
//                             </span>

//                             <span className="qb-meta-sep">
//                               |
//                             </span>

//                             <span>
//                               Duration:{" "}
//                               {section.durationMinutes ??
//                                 "—"}{" "}
//                               minutes
//                             </span>
//                           </div>
//                         </div>
//                       </div>

//                       <div className="d-flex gap-2">
//                         <button
//                           type="button"
//                           className="btn btn-outline-primary btn-sm d-inline-flex align-items-center gap-2"
//                           onClick={() =>
//                             setConfigOpen(true)
//                           }
//                         >
//                           <i className="bi bi-pencil" />
//                           Edit Section
//                         </button>
//                       </div>
//                     </div>

//                     {/* PDF files */}
//                     <div className="mb-4">
//                       <div className="d-flex justify-content-between align-items-center mb-2">
//                         <h4 className="h6 fw-bold mb-0">
//                           PDF Files (
//                           {activeTab === "mcq"
//                             ? "MCQ"
//                             : "Essay"}
//                           )
//                         </h4>

//                         <button
//                           type="button"
//                           className="btn btn-primary btn-sm d-inline-flex align-items-center gap-2"
//                           onClick={
//                             openUploadDialog
//                           }
//                           disabled={uploading}
//                         >
//                           <i className="bi bi-plus-lg" />

//                           {uploading
//                             ? "Uploading..."
//                             : `Upload ${
//                                 activeTab ===
//                                 "mcq"
//                                   ? "MCQ"
//                                   : "Essay"
//                               } PDF`}
//                         </button>

//                         <input
//                           ref={
//                             uploadInputRef
//                           }
//                           type="file"
//                           accept="application/pdf,.pdf"
//                           className="d-none"
//                           onChange={
//                             handlePdfSelected
//                           }
//                         />
//                       </div>

//                       <div className="table-responsive">
//                         <table className="table admin-table align-middle mb-0">
//                           <thead>
//                             <tr>
//                               <th
//                                 style={{
//                                   width: 32,
//                                 }}
//                               >
//                                 #
//                               </th>

//                               <th
//                                 style={{
//                                   width: 32,
//                                 }}
//                               >
//                                 <input
//                                   type="checkbox"
//                                   disabled={
//                                     documents.length ===
//                                     0
//                                   }
//                                 />
//                               </th>

//                               <th>
//                                 File Name
//                               </th>

//                               <th>
//                                 Uploaded On
//                               </th>

//                               <th>
//                                 Questions Extracted
//                               </th>

//                               <th>
//                                 Select for Exam
//                               </th>

//                               <th>
//                                 Marks
//                               </th>

//                               <th>
//                                 Status
//                               </th>

//                               <th>
//                                 Actions
//                               </th>
//                             </tr>
//                           </thead>

//                           <tbody>
//                             {documentsLoading ? (
//                               <tr>
//                                 <td
//                                   colSpan={9}
//                                   className="text-center py-4"
//                                 >
//                                   <div
//                                     className="spinner-border spinner-border-sm text-primary"
//                                     role="status"
//                                   />
//                                 </td>
//                               </tr>
//                             ) : documents.length ===
//                               0 ? (
//                               <tr>
//                                 <td
//                                   colSpan={9}
//                                   className="text-center text-muted py-4"
//                                 >
//                                   No PDF files uploaded
//                                   for this section.
//                                 </td>
//                               </tr>
//                             ) : (
//                               documents.map(
//                                 (
//                                   document,
//                                   index
//                                 ) => (
//                                   <tr
//                                     key={
//                                       document.id
//                                     }
//                                   >
//                                     <td>
//                                       {index +
//                                         1}
//                                     </td>

//                                     <td>
//                                       <input
//                                         type="checkbox"
//                                       />
//                                     </td>

//                                     <td className="fw-semibold">
//                                       {document.name}
//                                     </td>

//                                     <td>
//                                       {
//                                         document.uploadedOn
//                                       }
//                                     </td>

//                                     <td>
//                                       {document.extracted.toLocaleString()}
//                                     </td>

//                                     <td style={{ minWidth: 180 }}>
//                                       <div className="d-flex align-items-center gap-2">
//                                         <input
//                                           type="number"
//                                           min="0"
//                                           max={document.extracted}
//                                           className="form-control form-control-sm"
//                                           style={{ width: 82 }}
//                                           aria-label={`Questions to select from ${document.name}`}
//                                           value={
//                                             pdfAllocationDrafts[document.id] ??
//                                             String(document.selectionCount ?? 0)
//                                           }
//                                           onChange={(event) =>
//                                             setPdfAllocationDrafts((previous) => ({
//                                               ...previous,
//                                               [document.id]: event.target.value,
//                                             }))
//                                           }
//                                         />
//                                         <button
//                                           type="button"
//                                           className="btn btn-outline-primary btn-sm"
//                                           onClick={() => handleSavePdfAllocation(document)}
//                                           disabled={savingPdfAllocationId === document.id}
//                                         >
//                                           {savingPdfAllocationId === document.id
//                                             ? "Saving..."
//                                             : "Save"}
//                                         </button>
//                                       </div>
//                                       <small className="text-muted d-block mt-1">
//                                         of {document.extracted} available
//                                       </small>
//                                     </td>

//                                     <td style={{ minWidth: 180 }}>
//                                       <div className="d-flex align-items-center gap-2">
//                                         <input
//                                           type="number"
//                                           min="0"
//                                           step="any"
//                                           className="form-control form-control-sm"
//                                           style={{ width: 82 }}
//                                           aria-label={`Marks per question for ${document.name}`}
//                                           value={
//                                             pdfMarksDrafts[document.id] ??
//                                             String(document.marksPerQuestion ?? 0)
//                                           }
//                                           onChange={(event) =>
//                                             setPdfMarksDrafts((previous) => ({
//                                               ...previous,
//                                               [document.id]: event.target.value,
//                                             }))
//                                           }
//                                         />
//                                         <button
//                                           type="button"
//                                           className="btn btn-outline-primary btn-sm"
//                                           onClick={() => handleSavePdfMarks(document)}
//                                           disabled={savingPdfMarksId === document.id}
//                                         >
//                                           {savingPdfMarksId === document.id
//                                             ? "Saving..."
//                                             : "Save"}
//                                         </button>
//                                       </div>
//                                       <small className="text-muted d-block mt-1">
//                                         Marks per question
//                                       </small>
//                                     </td>

//                                     <td>
//                                       <StatusPill
//                                         status={
//                                           document.status ===
//                                           "COMPLETED"
//                                             ? "Completed"
//                                             : document.status
//                                         }
//                                       />
//                                     </td>

//                                     <td>
//                                       <div className="d-flex gap-2">
//                                         {document.pdfFile && (
//                                           <IconBtn
//                                             variant="primary"
//                                             icon="bi-eye"
//                                             onClick={() =>
//                                               window.open(
//                                                 document.pdfFile,
//                                                 "_blank",
//                                                 "noopener,noreferrer"
//                                               )
//                                             }
//                                           >
//                                             View
//                                           </IconBtn>
//                                         )}

//                                         <IconBtn
//                                           variant="danger"
//                                           icon="bi-trash"
//                                           onClick={() =>
//                                             handleDeleteDocument(
//                                               document
//                                             )
//                                           }
//                                         >
//                                           Delete
//                                         </IconBtn>
//                                       </div>
//                                     </td>
//                                   </tr>
//                                 )
//                               )
//                             )}
//                           </tbody>
//                         </table>
//                       </div>
//                     </div>

//                     {/* Questions */}
//                     <div className="flex-grow-1 d-flex flex-column">
//                       <h4 className="h6 fw-bold mb-2">
//                         Questions (
//                         {activeTab === "mcq"
//                           ? "MCQ"
//                           : "Essay"}
//                         )
//                       </h4>

//                       <div className="d-flex flex-wrap gap-2 mb-3 qb-filters-row">
//                         <div
//                           className="position-relative flex-grow-1"
//                           style={{
//                             minWidth: 220,
//                           }}
//                         >
//                           <i
//                             className="bi bi-search position-absolute"
//                             style={{
//                               left: 12,
//                               top: "50%",
//                               transform:
//                                 "translateY(-50%)",
//                               color:
//                                 "var(--oes-text-muted)",
//                             }}
//                           />

//                           <input
//                             type="text"
//                             className="form-control ps-4"
//                             placeholder="Search questions..."
//                             value={search}
//                             onChange={(
//                               event
//                             ) => {
//                               setSearch(
//                                 event.target
//                                   .value
//                               );
//                               setPage(1);
//                             }}
//                           />
//                         </div>

//                         <select
//                           className="form-select"
//                           style={{
//                             maxWidth: 160,
//                           }}
//                           value={chapter}
//                           onChange={(
//                             event
//                           ) => {
//                             setChapter(
//                               event.target
//                                 .value
//                             );
//                             setPage(1);
//                           }}
//                           disabled={
//                             chapters.length <=
//                             1
//                           }
//                         >
//                           {chapters.map(
//                             (value) => (
//                               <option
//                                 key={value}
//                                 value={value}
//                               >
//                                 {value}
//                               </option>
//                             )
//                           )}
//                         </select>

//                         <select
//                           className="form-select"
//                           style={{
//                             maxWidth: 140,
//                           }}
//                           value={status}
//                           onChange={(
//                             event
//                           ) => {
//                             setStatus(
//                               event.target
//                                 .value
//                             );
//                             setPage(1);
//                           }}
//                         >
//                           <option value="All">
//                             All
//                           </option>

//                           <option value="Active">
//                             Active
//                           </option>

//                           <option value="Inactive">
//                             Inactive
//                           </option>
//                         </select>

//                         <button
//                           type="button"
//                           className="btn btn-outline-secondary d-inline-flex align-items-center gap-2"
//                           onClick={
//                             resetFilters
//                           }
//                         >
//                           <i className="bi bi-arrow-counterclockwise" />
//                           Reset
//                         </button>

//                         <div className="position-relative">
//                           <button
//                             type="button"
//                             className="btn btn-outline-secondary d-inline-flex align-items-center gap-2"
//                             onClick={() =>
//                               setBulkMenuOpen(
//                                 (value) =>
//                                   !value
//                               )
//                             }
//                             disabled={
//                               selectedQuestions.length ===
//                               0
//                             }
//                           >
//                             <i className="bi bi-sliders" />
//                             Bulk Actions
//                           </button>

//                           {bulkMenuOpen && (
//                             <div className="qb-bulk-menu">
//                               <button
//                                 type="button"
//                                 onClick={() =>
//                                   handleBulkStatus(
//                                     true
//                                   )
//                                 }
//                               >
//                                 Mark as Active
//                               </button>

//                               <button
//                                 type="button"
//                                 onClick={() =>
//                                   handleBulkStatus(
//                                     false
//                                   )
//                                 }
//                               >
//                                 Mark as Inactive
//                               </button>

//                               <button
//                                 type="button"
//                                 className="text-danger"
//                                 onClick={
//                                   handleBulkDelete
//                                 }
//                               >
//                                 Delete selected
//                               </button>
//                             </div>
//                           )}
//                         </div>
//                       </div>

//                       <div className="table-responsive">
//                         <table className="table admin-table align-middle mb-0">
//                           <thead>
//                             <tr>
//                               <th
//                                 style={{
//                                   width: 32,
//                                 }}
//                               >
//                                 #
//                               </th>

//                               <th
//                                 style={{
//                                   width: 32,
//                                 }}
//                               >
//                                 <input
//                                   type="checkbox"
//                                   checked={
//                                     visibleQuestions.length >
//                                       0 &&
//                                     visibleQuestions.every(
//                                       (
//                                         question
//                                       ) =>
//                                         selectedQuestions.includes(
//                                           question.id
//                                         )
//                                     )
//                                   }
//                                   onChange={
//                                     toggleAllQuestions
//                                   }
//                                   disabled={
//                                     visibleQuestions.length ===
//                                     0
//                                   }
//                                 />
//                               </th>

//                               <th>
//                                 Question
//                               </th>

//                               <th>
//                                 Chapter
//                               </th>

//                               <th>
//                                 Status
//                               </th>

//                               <th>
//                                 Actions
//                               </th>
//                             </tr>
//                           </thead>

//                           <tbody>
//                             {questionsLoading ? (
//                               <tr>
//                                 <td
//                                   colSpan={6}
//                                   className="text-center py-5"
//                                 >
//                                   <div
//                                     className="spinner-border text-primary"
//                                     role="status"
//                                   />

//                                   <div className="text-muted mt-2">
//                                     Loading questions...
//                                   </div>
//                                 </td>
//                               </tr>
//                             ) : visibleQuestions.length ===
//                               0 ? (
//                               <tr>
//                                 <td
//                                   colSpan={6}
//                                   className="text-center text-muted py-5"
//                                 >
//                                   No questions match
//                                   your filters.
//                                 </td>
//                               </tr>
//                             ) : (
//                               visibleQuestions.map(
//                                 (
//                                   question,
//                                   index
//                                 ) => (
//                                   <tr
//                                     key={
//                                       question.id
//                                     }
//                                   >
//                                     <td>
//                                       {(page -
//                                         1) *
//                                         PAGE_SIZE +
//                                         index +
//                                         1}
//                                     </td>

//                                     <td>
//                                       <input
//                                         type="checkbox"
//                                         checked={selectedQuestions.includes(
//                                           question.id
//                                         )}
//                                         onChange={() =>
//                                           toggleQuestion(
//                                             question.id
//                                           )
//                                         }
//                                       />
//                                     </td>

//                                     <td>
//                                       {question.text ||
//                                         "—"}
//                                     </td>

//                                     <td>
//                                       {question.chapter ||
//                                         "—"}
//                                     </td>

//                                     <td>
//                                       <StatusPill
//                                         status={
//                                           question.status
//                                         }
//                                       />
//                                     </td>

//                                     <td>
//                                       <div className="d-flex gap-2 flex-wrap">
//                                         <IconBtn
//                                           variant="primary"
//                                           icon={
//                                             question.status ===
//                                             "Active"
//                                               ? "bi-pause-circle"
//                                               : "bi-check-circle"
//                                           }
//                                           onClick={() =>
//                                             handleToggleQuestionStatus(
//                                               question
//                                             )
//                                           }
//                                         >
//                                           {question.status ===
//                                           "Active"
//                                             ? "Inactive"
//                                             : "Active"}
//                                         </IconBtn>

//                                         <IconBtn
//                                           variant="danger"
//                                           icon="bi-trash"
//                                           onClick={() =>
//                                             handleDeleteQuestion(
//                                               question
//                                             )
//                                           }
//                                         >
//                                           Delete
//                                         </IconBtn>
//                                       </div>
//                                     </td>
//                                   </tr>
//                                 )
//                               )
//                             )}
//                           </tbody>
//                         </table>
//                       </div>

//                       <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mt-3">
//                         <small className="text-muted">
//                           Showing {startIdx} to{" "}
//                           {endIdx} of{" "}
//                           {filteredQuestions.length.toLocaleString()}{" "}
//                           filtered questions
//                         </small>

//                         <nav>
//                           <ul className="pagination mb-0">
//                             <li
//                               className={`page-item ${
//                                 page === 1
//                                   ? "disabled"
//                                   : ""
//                               }`}
//                             >
//                               <button
//                                 className="page-link"
//                                 onClick={() =>
//                                   setPage(
//                                     (
//                                       value
//                                     ) =>
//                                       Math.max(
//                                         1,
//                                         value -
//                                           1
//                                       )
//                                   )
//                                 }
//                               >
//                                 <i className="bi bi-chevron-left" />
//                               </button>
//                             </li>

//                             {getPages().map(
//                               (
//                                 pageNumber,
//                                 index
//                               ) =>
//                                 pageNumber ===
//                                 "ellipsis" ? (
//                                   <li
//                                     key={`ellipsis-${index}`}
//                                     className="page-item disabled"
//                                   >
//                                     <span className="page-link">
//                                       …
//                                     </span>
//                                   </li>
//                                 ) : (
//                                   <li
//                                     key={
//                                       pageNumber
//                                     }
//                                     className={`page-item ${
//                                       page ===
//                                       pageNumber
//                                         ? "active"
//                                         : ""
//                                     }`}
//                                   >
//                                     <button
//                                       className="page-link"
//                                       onClick={() =>
//                                         setPage(
//                                           pageNumber
//                                         )
//                                       }
//                                     >
//                                       {
//                                         pageNumber
//                                       }
//                                     </button>
//                                   </li>
//                                 )
//                             )}

//                             <li
//                               className={`page-item ${
//                                 page ===
//                                 totalPages
//                                   ? "disabled"
//                                   : ""
//                               }`}
//                             >
//                               <button
//                                 className="page-link"
//                                 onClick={() =>
//                                   setPage(
//                                     (
//                                       value
//                                     ) =>
//                                       Math.min(
//                                         totalPages,
//                                         value +
//                                           1
//                                       )
//                                   )
//                                 }
//                               >
//                                 <i className="bi bi-chevron-right" />
//                               </button>
//                             </li>
//                           </ul>
//                         </nav>
//                       </div>

//                       <div className="d-flex align-items-center gap-3 flex-wrap mt-3">
//                         <button
//                           type="button"
//                           className="btn btn-outline-danger d-inline-flex align-items-center gap-2"
//                           onClick={
//                             handleDeleteAllQuestions
//                           }
//                           disabled={
//                             questions.length ===
//                             0
//                           }
//                         >
//                           <i className="bi bi-trash" />

//                           Delete All{" "}
//                           {activeTab === "mcq"
//                             ? "MCQ"
//                             : "Essay"}{" "}
//                           Questions
//                         </button>

//                         <div className="alert alert-danger py-2 px-3 mb-0 small flex-grow-1 d-flex align-items-center gap-2">
//                           <i className="bi bi-exclamation-triangle" />

//                           This permanently
//                           deletes all questions
//                           in this section. PDF
//                           files will not be
//                           deleted.
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Right configuration */}
//                 {configOpen && (
//                   <div className="col-12 col-xl-4">
//                     <div className="d-flex flex-column gap-3 h-100">
//                       <div className="admin-card p-3 p-md-4">
//                         <h3 className="h6 fw-bold mb-3 d-flex align-items-center gap-2">
//                           <i className="bi bi-gear" />

//                           Section Configuration (
//                           {activeTab === "mcq"
//                             ? "MCQ"
//                             : "Essay"}
//                           )
//                         </h3>

//                         <div className="mb-3">
//                           <label className="form-label">
//                             Section Name
//                           </label>

//                           <input
//                             type="text"
//                             className="form-control"
//                             value={
//                               sectionName
//                             }
//                             onChange={(
//                               event
//                             ) =>
//                               setSectionName(
//                                 event.target
//                                   .value
//                               )
//                             }
//                           />
//                         </div>

//                         <div className="row g-3 mb-1">
//                           <div className="col-7">
//                             <label className="form-label">
//                               Question Type
//                             </label>

//                             <select
//                               className="form-select"
//                               disabled
//                               value={
//                                 activeTab ===
//                                 "mcq"
//                                   ? "MCQ"
//                                   : "Essay"
//                               }
//                               onChange={() => {}}
//                             >
//                               <option>
//                                 {activeTab ===
//                                 "mcq"
//                                   ? "MCQ (Multiple Choice)"
//                                   : "Essay (Written Answer)"}
//                               </option>
//                             </select>
//                           </div>

//                           <div className="col-5">
//                             <label className="form-label">
//                               Marks per Question{" "}
//                               <span className="text-danger">
//                                 *
//                               </span>
//                             </label>

//                             <input
//                               type="number"
//                               min="0"
//                               className="form-control"
//                               value={
//                                 marksPerQuestion
//                               }
//                               onChange={(
//                                 event
//                               ) =>
//                                 setMarksPerQuestion(
//                                   event.target
//                                     .value
//                                 )
//                               }
//                             />
//                           </div>
//                         </div>

//                         <small className="text-muted d-block mb-3">
//                           This value is stored in
//                           the exam section
//                           configuration.
//                         </small>

//                         <div className="row g-3 mb-4">
//                           <div className="col-7">
//                             <label className="form-label">
//                               Duration (Minutes)
//                             </label>

//                             <input
//                               type="number"
//                               min="1"
//                               className="form-control"
//                               value={
//                                 duration
//                               }
//                               onChange={(
//                                 event
//                               ) =>
//                                 setDuration(
//                                   event.target
//                                     .value
//                                 )
//                               }
//                             />
//                           </div>

//                           <div className="col-5">
//                             <label className="form-label">
//                               Status
//                             </label>

//                             <input
//                               type="text"
//                               className="form-control"
//                               value="Configured"
//                               disabled
//                               readOnly
//                             />
//                           </div>
//                         </div>

//                         <div className="d-flex justify-content-end gap-2">
//                           <button
//                             type="button"
//                             className="btn btn-outline-secondary"
//                             onClick={() => {
//                               setSectionName(
//                                 section.name ||
//                                   ""
//                               );
//                               setMarksPerQuestion(
//                                 section.marks ??
//                                   ""
//                               );
//                               setDuration(
//                                 section.durationMinutes ??
//                                   ""
//                               );
//                               setActionError(
//                                 ""
//                               );
//                             }}
//                           >
//                             Cancel
//                           </button>

//                           <button
//                             type="button"
//                             className="btn btn-primary"
//                             onClick={
//                               handleSaveSection
//                             }
//                             disabled={
//                               savingSection
//                             }
//                           >
//                             {savingSection
//                               ? "Saving..."
//                               : "Save Changes"}
//                           </button>
//                         </div>
//                       </div>

//                       <div className="qb-notes-box">
//                         <h4 className="h6 fw-bold mb-2 d-flex align-items-center gap-2">
//                           <i className="bi bi-info-circle" />

//                           Important Notes
//                         </h4>

//                         <ul>
//                           <li>
//                             MCQ and Essay
//                             questions are managed
//                             separately.
//                           </li>

//                           <li>
//                             Marks and duration are
//                             stored in the section
//                             configuration.
//                           </li>

//                           <li>
//                             You can upload multiple
//                             PDFs through the existing
//                             question parser.
//                           </li>

//                           <li>
//                             Removing a PDF deactivates
//                             its questions for future
//                             exam selection. Historical
//                             attempts are retained.
//                           </li>

//                           <li>
//                             Questions can be deleted
//                             individually or in bulk.
//                           </li>
//                         </ul>
//                       </div>

//                       <div className="admin-card p-3 p-md-4">
//                         <h4 className="h6 fw-bold mb-3 d-flex align-items-center gap-2 text-success">
//                           <i className="bi bi-check-circle" />

//                           Section Actions
//                         </h4>

//                         <div className="qb-action-row">
//                           <div className="d-flex align-items-center gap-2">
//                             <button
//                               type="button"
//                               className="qb-btn-soft-primary btn d-inline-flex align-items-center gap-2"
//                               onClick={
//                                 openUploadDialog
//                               }
//                               disabled={
//                                 uploading
//                               }
//                             >
//                               <i className="bi bi-cloud-arrow-up" />

//                               {uploading
//                                 ? "Uploading..."
//                                 : `Upload More ${
//                                     activeTab ===
//                                     "mcq"
//                                       ? "MCQ"
//                                       : "Essay"
//                                   } PDF`}
//                             </button>
//                           </div>

//                           <small className="text-muted">
//                             Add more questions
//                             through the existing
//                             PDF parser.
//                           </small>
//                         </div>

//                         <div className="qb-action-row">
//                           <button
//                             type="button"
//                             className="qb-btn-soft-danger btn d-inline-flex align-items-center gap-2"
//                             onClick={
//                               handleDeleteAllQuestions
//                             }
//                             disabled={
//                               questions.length ===
//                               0
//                             }
//                           >
//                             <i className="bi bi-trash" />

//                             Delete All{" "}
//                             {activeTab ===
//                             "mcq"
//                               ? "MCQ"
//                               : "Essay"}{" "}
//                             Questions
//                           </button>

//                           <small className="text-muted">
//                             Permanently delete
//                             all questions in
//                             this section.
//                           </small>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             )}
//           </>
//         )}
//       </div>
//     </div>
//   );
// }


import React, { useEffect, useMemo, useRef, useState } from "react";

import AdminSidebar from "./AdminSidebar";
import AdminTopbar from "./Admintopbar";

import {
  getAdminExams,
  updateExam,
  getSections,
  addSection,
  updateSection,
  getAdminQuestions,
  updateAdminQuestion,
  deleteAdminQuestion,
  bulkDeleteAdminQuestions,
  getQuestionDocuments,
  updateQuestionDocument,
  deleteQuestionDocument,
  uploadQuestionBankPdf,
} from "../api/adminclient";

import { apiErrorMessage } from "../api/auth";

/* =========================================================
   Question Bank — Admin Panel

   Django-connected version.

   The existing UI/design is preserved, but the data now comes
   from the Django admin APIs.

   PDF upload continues to use the existing Django parser/importer:
       POST /api/exams/upload/

   Reprocess functionality has intentionally been removed.
   ========================================================= */

const PAGE_SIZE = 5;

function StatusPill({ status }) {
  const cls =
    status === "Active"
      ? "active"
      : status === "Inactive"
        ? "inactive"
        : "pending";

  return (
    <span className={`admin-status-pill ${cls}`}>
      {status}
    </span>
  );
}

function IconBtn({
  variant = "primary",
  icon,
  children,
  onClick,
  title,
  disabled = false,
}) {
  return (
    <button
      type="button"
      className={`qb-btn-soft-${variant} btn btn-sm d-inline-flex align-items-center gap-1`}
      onClick={onClick}
      title={title}
      disabled={disabled}
    >
      <i className={`bi ${icon}`} />
      {children}
    </button>
  );
}

function formatDate(value) {
  if (!value) return "—";

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return String(value);
  }

  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

function normalizeQuestion(question) {
  return {
    ...question,
    text: question.question_text || question.questionText || "",
    status:
      question.status ||
      (question.is_active === false ? "Inactive" : "Active"),
    chapter:
      question.answer_data?.chapter ||
      question.answer_data?.Chapter ||
      "—",
  };
}

function normalizeDocument(document) {
  return {
    ...document,
    name:
      document.fileName ||
      document.file_name ||
      document.title ||
      "Question Bank PDF",
    uploadedOn: formatDate(
      document.uploadedAt ||
      document.uploaded_at ||
      document.created_at ||
      document.createdAt
    ),
    extracted: Number(
      document.questionsExtracted ??
      document.questions_extracted ??
      document.extracted_questions_count ??
      document.question_count ??
      0
    ),
    selectionCount: Number(
      document.selectionCount ??
      document.selection_count ??
      0
    ),
    marksPerQuestion: Number(
      document.marksPerQuestion ??
      document.marks_per_question ??
      0
    ),
    pdfFile:
      document.pdfFile ||
      document.pdf_file ||
      document.file ||
      document.file_url ||
      "",
    status:
      document.processingStatus ||
      document.processing_status ||
      document.status ||
      "Pending",
  };
}

function getSectionType(section) {
  const type = String(
    section?.type ||
    section?.sectionType ||
    section?.section_type ||
    ""
  ).toUpperCase();

  if (type.includes("ESSAY")) {
    return "essay";
  }

  return "mcq";
}

export default function QuestionBank() {
  const [exams, setExams] = useState([]);
  const [sections, setSections] = useState([]);

  const [selectedExamId, setSelectedExamId] = useState("");
  const [activeSectionId, setActiveSectionId] = useState("");

  const [questions, setQuestions] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [pdfAllocationDrafts, setPdfAllocationDrafts] = useState({});
  const [savingPdfAllocationId, setSavingPdfAllocationId] = useState(null);
  const [pdfMarksDrafts, setPdfMarksDrafts] = useState({});
const [savingPdfMarksId, setSavingPdfMarksId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [questionsLoading, setQuestionsLoading] = useState(false);
  const [documentsLoading, setDocumentsLoading] = useState(false);

  const [error, setError] = useState("");
  const [actionError, setActionError] = useState("");

  const [search, setSearch] = useState("");
  const [chapter, setChapter] = useState("All");
  const [status, setStatus] = useState("All");

  const [page, setPage] = useState(1);
  const [selectedQuestions, setSelectedQuestions] = useState([]);
  const [bulkMenuOpen, setBulkMenuOpen] = useState(false);

  const [configOpen, setConfigOpen] = useState(true);

  const [sectionName, setSectionName] = useState("");
  const [marksPerQuestion, setMarksPerQuestion] = useState("");
  const [duration, setDuration] = useState("");
  const [sectionQuestionCount, setSectionQuestionCount] = useState("");
  const [qualificationType, setQualificationType] = useState("NONE");
  const [qualificationValue, setQualificationValue] = useState("");
  const [breakDurationDraft, setBreakDurationDraft] = useState("0");
  const [savingBreakDuration, setSavingBreakDuration] = useState(false);

  const [savingSection, setSavingSection] = useState(false);

  // Generic section creation allows missing sections to be restored
  // without hard-coding any exam names or changing existing sections.
  const [createSectionOpen, setCreateSectionOpen] = useState(false);
  const [creatingSection, setCreatingSection] = useState(false);
  const [newSection, setNewSection] = useState({
    name: "",
    type: "MCQ",
    questions: "",
    marks: "1",
    durationMinutes: "70",
    sectionOrder: "",
    qualificationType: "NONE",
    qualificationValue: "",
  });

  const [uploading, setUploading] = useState(false);
  const [uploadTitle, setUploadTitle] = useState("");

  const uploadInputRef = useRef(null);

  /* =========================================================
     Load exams
     ========================================================= */

  useEffect(() => {
    let mounted = true;

    async function loadExams() {
      setLoading(true);
      setError("");

      try {
        const response = await getAdminExams();

        if (!mounted) return;

        const data = Array.isArray(response.data)
          ? response.data
          : response.data?.results || [];

        setExams(data);

        if (data.length > 0) {
          setSelectedExamId(data[0].id);
        }
      } catch (err) {
        if (mounted) {
          setError(
            apiErrorMessage(
              err,
              "Could not load exams."
            )
          );
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    }

    loadExams();

    return () => {
      mounted = false;
    };
  }, []);

  /* =========================================================
     Load sections whenever exam changes
     ========================================================= */

  
useEffect(() => {
  let mounted = true;

  async function loadSections() {
    if (!selectedExamId) {
      setSections([]);
      setActiveSectionId("");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await getSections();

      if (!mounted) return;

      const responseData = response.data;

      const allSections = Array.isArray(responseData)
        ? responseData
        : responseData?.results ||
          responseData?.data ||
          [];

      const getSectionExamId = (section) => {
        const exam =
          section.examId ??
          section.exam_id ??
          section.exam;

        if (exam && typeof exam === "object") {
          return (
            exam.id ??
            exam.pk ??
            exam.examId ??
            exam.exam_id ??
            ""
          );
        }

        return exam ?? "";
      };

      let examSections = allSections.filter(
        (section) =>
          String(getSectionExamId(section)) ===
          String(selectedExamId)
      );

      // Fallback: ask Django for this exam's sections directly.
      if (examSections.length === 0) {
        const filteredResponse = await getSections(selectedExamId);

        if (!mounted) return;

        const filteredPayload = filteredResponse.data;

        examSections = Array.isArray(filteredPayload)
          ? filteredPayload
          : filteredPayload?.results ||
            filteredPayload?.data ||
            [];

        // Never display sections belonging to another exam.
        examSections = examSections.filter((section) => {
          const sectionExamId = getSectionExamId(section);

          return (
            !sectionExamId ||
            String(sectionExamId) === String(selectedExamId)
          );
        });
      }

      setSections(examSections);

      setActiveSectionId((previousId) => {
        const previousStillExists = examSections.some(
          (section) =>
            String(section.id) === String(previousId)
        );

        if (previousStillExists) {
          return String(previousId);
        }

        return examSections.length
          ? String(examSections[0].id)
          : "";
      });
    } catch (error) {
      if (mounted) {
        setError(
          error?.response?.data?.detail ||
            error?.response?.data?.message ||
            error?.message ||
            "Could not load exam sections."
        );
      }
    } finally {
      if (mounted) {
        setLoading(false);
      }
    }
  }

  loadSections();

  return () => {
    mounted = false;
  };
}, [selectedExamId]);

  /* =========================================================
     Current exam / sections
     ========================================================= */

  const currentExam = useMemo(() => {
    return exams.find(
      (exam) => String(exam.id) === String(selectedExamId)
    );
  }, [exams, selectedExamId]);

  // Break configuration is shown only for the three EA exam parts.
  // Support common API naming variants without changing CMA/ACCA settings.
  const isEaPart = useMemo(() => {
    const examLabel = String(
      currentExam?.name ?? currentExam?.title ?? currentExam?.code ?? currentExam?.exam_name ?? ""
    ).trim().toLowerCase();
    return /\bea\s*(part\s*)?[1-3]\b/.test(examLabel) || /\bea[-_ ]?part[-_ ]?[1-3]\b/.test(examLabel);
  }, [currentExam]);

  useEffect(() => {
    const configuredBreak = currentExam?.breakDurationMinutes ?? currentExam?.break_duration_minutes ?? 0;
    setBreakDurationDraft(String(configuredBreak));
  }, [currentExam?.id, currentExam?.breakDurationMinutes, currentExam?.break_duration_minutes]);

  const mcqSections = useMemo(
    () => sections.filter((item) => getSectionType(item) === "mcq"),
    [sections]
  );

  const essaySections = useMemo(
    () => sections.filter((item) => getSectionType(item) === "essay"),
    [sections]
  );

  const section = useMemo(
    () => sections.find(
      (item) => String(item.id) === String(activeSectionId)
    ) || null,
    [sections, activeSectionId]
  );

  const activeSectionType = section ? getSectionType(section) : "mcq";
  const activeSectionTypeLabel = activeSectionType === "essay" ? "Essay" : "MCQ";
  const activeSectionTypeLongLabel = activeSectionType === "essay"
    ? "Essay (Written Answer)"
    : "MCQ (Multiple Choice)";

  /* =========================================================
     Load questions + PDFs for current section
     ========================================================= */

  async function loadQuestionBank(sectionId = section?.id) {
    if (!sectionId) {
      setQuestions([]);
      setDocuments([]);
      
      return;
    }

    setQuestionsLoading(true);
    setDocumentsLoading(true);
    setActionError("");

    try {
      const [questionResponse, documentResponse] =
        await Promise.all([
          getAdminQuestions(sectionId),
          getQuestionDocuments(sectionId),
        ]);

      const questionData = Array.isArray(questionResponse.data)
        ? questionResponse.data
        : questionResponse.data?.results || [];

      const documentData = Array.isArray(documentResponse.data)
        ? documentResponse.data
        : documentResponse.data?.results || [];

      setQuestions(
        questionData.map(normalizeQuestion)
      );
      

      const normalizedDocuments = documentData.map(normalizeDocument);
      setDocuments(normalizedDocuments);
      setPdfAllocationDrafts(
        Object.fromEntries(
          normalizedDocuments.map((document) => [
            document.id,
            String(document.selectionCount ?? 0),
          ])
        )
      );
      setPdfMarksDrafts(
        Object.fromEntries(
          normalizedDocuments.map((document) => [
            document.id,
            String(document.marksPerQuestion ?? 0),
          ])
        )
      );
    } catch (err) {
      setActionError(
        apiErrorMessage(
          err,
          "Could not load the Question Bank."
        )
      );
    } finally {
      setQuestionsLoading(false);
      setDocumentsLoading(false);
    }
  }

  useEffect(() => {
    setSearch("");
    setChapter("All");
    setStatus("All");
    setPage(1);
    setSelectedQuestions([]);
    setBulkMenuOpen(false);

    if (section?.id) {
      setSectionName(section.name || "");
      setMarksPerQuestion(
        section.marks ?? ""
      );
      setDuration(
        section.durationMinutes ?? section.duration_minutes ?? ""
      );
      setSectionQuestionCount(section.questions ?? section.questionCount ?? section.question_count ?? "");
      setQualificationType(section.qualificationType ?? section.qualification_type ?? "NONE");
      setQualificationValue(section.qualificationValue ?? section.qualification_value ?? "");

      loadQuestionBank(section.id);
    } else {
      setQuestions([]);
      setDocuments([]);
      setSectionName("");
      setMarksPerQuestion("");
      setDuration("");
      setSectionQuestionCount("");
      setQualificationType("NONE");
      setQualificationValue("");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [section?.id]);

  /* =========================================================
     Derived values
     ========================================================= */

  const filteredQuestions = useMemo(() => {
    return questions.filter((question) => {
      const questionText =
        question.text?.toLowerCase() || "";

      const matchesSearch =
        questionText.includes(
          search.toLowerCase()
        );

      /*
       * Chapter is not a real Question model field.
       * Only use it if the parser supplied chapter information
       * inside answer_data.
       */
      const matchesChapter =
        chapter === "All" ||
        question.chapter === chapter;

      const matchesStatus =
        status === "All" ||
        question.status === status;

      return (
        matchesSearch &&
        matchesChapter &&
        matchesStatus
      );
    });
  }, [
    questions,
    search,
    chapter,
    status,
  ]);

  const totalPages = Math.max(
    1,
    Math.ceil(
      filteredQuestions.length / PAGE_SIZE
    )
  );

  const visibleQuestions = useMemo(() => {
    const start =
      (page - 1) * PAGE_SIZE;

    return filteredQuestions.slice(
      start,
      start + PAGE_SIZE
    );
  }, [filteredQuestions, page]);

  const totalQuestionCount =
    questions.length;

  const mcqQuestionCount = mcqSections.reduce(
    (total, item) => total + Number(item.questions || 0),
    0
  );

  const essayQuestionCount = essaySections.reduce(
    (total, item) => total + Number(item.questions || 0),
    0
  );

  const totalConfiguredQuestions =
    mcqQuestionCount +
    essayQuestionCount;

  const startIdx =
    filteredQuestions.length > 0
      ? (page - 1) * PAGE_SIZE + 1
      : 0;

  const endIdx =
    filteredQuestions.length > 0
      ? Math.min(
          page * PAGE_SIZE,
          filteredQuestions.length
        )
      : 0;

  const chapters = useMemo(() => {
    const values = questions
      .map((question) => question.chapter)
      .filter(
        (value) =>
          value &&
          value !== "—"
      );

    return [
      "All",
      ...Array.from(
        new Set(values)
      ),
    ];
  }, [questions]);

  async function handleSaveBreakDuration() {
    if (!selectedExamId) return;
    const value = Number(breakDurationDraft);
    if (!Number.isInteger(value) || value < 0) {
      setActionError("Break duration must be a non-negative whole number of minutes.");
      return;
    }
    setSavingBreakDuration(true);
    setActionError("");
    try {
      await updateExam(selectedExamId, { breakDurationMinutes: value });
      const response = await getAdminExams();
      const data = Array.isArray(response.data) ? response.data : response.data?.results || [];
      setExams(data);
      const refreshedExam = data.find((item) => String(item.id) === String(selectedExamId));
      if (refreshedExam) setBreakDurationDraft(String(refreshedExam.breakDurationMinutes ?? refreshedExam.break_duration_minutes ?? value));
    } catch (err) {
      setActionError(apiErrorMessage(err, "Could not save the break duration. Verify that the Django exam API accepts breakDurationMinutes."));
    } finally {
      setSavingBreakDuration(false);
    }
  }

  /* =========================================================
     Create a missing section (generic for every exam)
     ========================================================= */

  async function handleCreateSection() {
    if (!selectedExamId) {
      setActionError("Select an exam before creating a section.");
      return;
    }

    const name = newSection.name.trim();
    const questionsCount = Number(newSection.questions);
    const marksValue = Number(newSection.marks);
    const durationValue = Number(newSection.durationMinutes);
    const orderValue = newSection.sectionOrder === ""
      ? sections.reduce((max, item) => Math.max(max, Number(item.sectionOrder ?? item.section_order ?? 0)), 0) + 1
      : Number(newSection.sectionOrder);

    if (!name) return setActionError("Section name is required.");
    if (!Number.isInteger(questionsCount) || questionsCount < 1) {
      return setActionError("Question count must be a whole number greater than 0.");
    }
    if (!Number.isFinite(marksValue) || marksValue < 0) {
      return setActionError("Marks per question must be a valid non-negative number.");
    }
    if (!Number.isFinite(durationValue) || durationValue < 1) {
      return setActionError("Duration must be at least 1 minute.");
    }
    if (!Number.isInteger(orderValue) || orderValue < 1) {
      return setActionError("Section order must be a whole number greater than 0.");
    }
    if (sections.some((item) => Number(item.sectionOrder ?? item.section_order) === orderValue)) {
      return setActionError("That section order is already in use. Choose another order.");
    }

    setCreatingSection(true);
    setActionError("");
    try {
      const response = await addSection({
        examId: selectedExamId,
        name,
        type: newSection.type,
        questions: questionsCount,
        marks: marksValue,
        durationMinutes: durationValue,
        sectionOrder: orderValue,
        qualificationType: newSection.qualificationType,
        qualificationValue: newSection.qualificationValue === "" ? null : Number(newSection.qualificationValue),
        isActive: true,
      });

      const refreshed = await getSections(selectedExamId);
      const data = Array.isArray(refreshed.data) ? refreshed.data : refreshed.data?.results || [];
      setSections(data);
      const createdId = response?.data?.id;
      const created = data.find((item) => String(item.id) === String(createdId))
        || data.find((item) => String(item.name || "") === name && getSectionType(item) === (newSection.type === "ESSAY" ? "essay" : "mcq"));
      if (created) setActiveSectionId(String(created.id));
      setNewSection({
        name: "", type: "MCQ", questions: "", marks: "1", durationMinutes: "70",
        sectionOrder: "", qualificationType: "NONE", qualificationValue: "",
      });
      setCreateSectionOpen(false);
    } catch (err) {
      setActionError(apiErrorMessage(err, "Could not create the section. Check the section API and section-order field."));
    } finally {
      setCreatingSection(false);
    }
  }

  /* =========================================================
     Tab switching
     ========================================================= */

  function switchTab(sectionId) {
    setActiveSectionId(String(sectionId));
    setPage(1);
    setSelectedQuestions([]);
    setSearch("");
    setChapter("All");
    setStatus("All");
    setBulkMenuOpen(false);
  }

  /* =========================================================
     Selection
     ========================================================= */

  function toggleQuestion(id) {
    setSelectedQuestions((previous) =>
      previous.includes(id)
        ? previous.filter(
            (value) => value !== id
          )
        : [...previous, id]
    );
  }

  function toggleAllQuestions() {
    const visibleIds =
      visibleQuestions.map(
        (question) => question.id
      );

    const allSelected =
      visibleIds.length > 0 &&
      visibleIds.every((id) =>
        selectedQuestions.includes(id)
      );

    if (allSelected) {
      setSelectedQuestions(
        (previous) =>
          previous.filter(
            (id) =>
              !visibleIds.includes(id)
          )
      );
    } else {
      setSelectedQuestions((previous) => [
        ...new Set([
          ...previous,
          ...visibleIds,
        ]),
      ]);
    }
  }

  function resetFilters() {
    setSearch("");
    setChapter("All");
    setStatus("All");
    setPage(1);
  }

  /* =========================================================
     Question status
     ========================================================= */

  async function handleToggleQuestionStatus(
    question
  ) {
    setActionError("");

    try {
      const newStatus =
        question.status !== "Active";

      const response =
        await updateAdminQuestion(
          question.id,
          {
            is_active: newStatus,
          }
        );

      const updated =
        normalizeQuestion(response.data);

      setQuestions((previous) =>
        previous.map((item) =>
          item.id === question.id
            ? updated
            : item
        )
      );
    } catch (err) {
      setActionError(
        apiErrorMessage(
          err,
          "Could not update question status."
        )
      );
    }
  }

  /* =========================================================
     Delete individual question
     ========================================================= */

  async function handleDeleteQuestion(
    question
  ) {
    const confirmed =
      window.confirm(
        "Delete this question permanently?"
      );

    if (!confirmed) return;

    setActionError("");

    try {
      await deleteAdminQuestion(
        question.id
      );

      setQuestions((previous) =>
        previous.filter(
          (item) =>
            item.id !== question.id
        )
      );

      setSelectedQuestions((previous) =>
        previous.filter(
          (id) =>
            id !== question.id
        )
      );
    } catch (err) {
      setActionError(
        apiErrorMessage(
          err,
          "Could not delete question."
        )
      );
    }
  }

  /* =========================================================
     Bulk delete
     ========================================================= */

  async function handleBulkDelete() {
    if (
      selectedQuestions.length === 0
    ) {
      return;
    }

    const confirmed =
      window.confirm(
        `Delete ${selectedQuestions.length} selected question(s) permanently?`
      );

    if (!confirmed) return;

    setActionError("");

    try {
      await bulkDeleteAdminQuestions(
        selectedQuestions
      );

      const selectedSet =
        new Set(selectedQuestions);

      setQuestions((previous) =>
        previous.filter(
          (question) =>
            !selectedSet.has(
              question.id
            )
        )
      );

      setSelectedQuestions([]);
      setBulkMenuOpen(false);
    } catch (err) {
      setActionError(
        apiErrorMessage(
          err,
          "Could not delete selected questions."
        )
      );
    }
  }

  /* =========================================================
     Bulk activate/deactivate
     ========================================================= */

  async function handleBulkStatus(
    active
  ) {
    if (
      selectedQuestions.length === 0
    ) {
      return;
    }

    setActionError("");

    try {
      await Promise.all(
        selectedQuestions.map((id) =>
          updateAdminQuestion(
            id,
            {
              is_active: active,
            }
          )
        )
      );

      setQuestions((previous) =>
        previous.map((question) =>
          selectedQuestions.includes(
            question.id
          )
            ? {
                ...question,
                is_active: active,
                status: active
                  ? "Active"
                  : "Inactive",
              }
            : question
        )
      );

      setSelectedQuestions([]);
      setBulkMenuOpen(false);
    } catch (err) {
      setActionError(
        apiErrorMessage(
          err,
          "Could not update selected questions."
        )
      );
    }
  }

  /* =========================================================
     Delete all questions in current section
     ========================================================= */

  async function handleDeleteAllQuestions() {
    if (!section?.id) return;

    if (questions.length === 0) {
      return;
    }

    const confirmed =
      window.confirm(
        `This will permanently delete all ${questions.length} questions currently in this section. Continue?`
      );

    if (!confirmed) return;

    setActionError("");

    try {
      const ids =
        questions.map(
          (question) => question.id
        );

      await bulkDeleteAdminQuestions(ids);

      setQuestions([]);
      setSelectedQuestions([]);
      setPage(1);
    } catch (err) {
      setActionError(
        apiErrorMessage(
          err,
          "Could not delete all questions."
        )
      );
    }
  }

  /* =========================================================
     Delete PDF
     ========================================================= */

  async function handleDeleteDocument(
    document
  ) {
    const confirmed =
      window.confirm(
        `Remove "${document.name}"? Its questions will be deactivated for future exam selection. Existing attempts and their history will be retained.`
      );

    if (!confirmed) return;

    setActionError("");

    try {
      await deleteQuestionDocument(
        document.id
      );

      setDocuments((previous) =>
        previous.filter(
          (item) =>
            item.id !== document.id
        )
      );
    } catch (err) {
      setActionError(
        apiErrorMessage(
          err,
          "Could not delete PDF."
        )
      );
    }
  }

  /* =========================================================
     Save per-PDF question allocation
     ========================================================= */

  async function handleSavePdfAllocation(document) {
    const rawValue =
      pdfAllocationDrafts[document.id] ??
      document.selectionCount ??
      0;
    const value = Number(rawValue);

    if (!Number.isInteger(value) || value < 0) {
      setActionError("PDF allocation must be a non-negative whole number.");
      return;
    }

    if (value > document.extracted) {
      setActionError(
        `Allocation cannot exceed the ${document.extracted} questions extracted from this PDF.`
      );
      return;
    }

    setSavingPdfAllocationId(document.id);
    setActionError("");

    try {
      const response = await updateQuestionDocument(document.id, {
        selection_count: value,
      });
      const updated = normalizeDocument(response.data || {
        ...document,
        selection_count: value,
      });

      setDocuments((previous) =>
        previous.map((item) =>
          String(item.id) === String(document.id) ? updated : item
        )
      );
      setPdfAllocationDrafts((previous) => ({
        ...previous,
        [document.id]: String(updated.selectionCount ?? value),
      }));
    } catch (err) {
      setActionError(
        apiErrorMessage(err, "Could not save this PDF's question allocation.")
      );
    } finally {
      setSavingPdfAllocationId(null);
    }
  }

  /* =========================================================
     Save per-PDF marks
     ========================================================= */

  

async function handleSavePdfMarks(document) {
  const rawValue =
    pdfMarksDrafts[document.id] ??
    String(document.marksPerQuestion ?? 0);

  const value = Number(rawValue);

  if (
    rawValue === "" ||
    !Number.isFinite(value) ||
    value < 0
  ) {
    setActionError(
      "Marks must be a valid non-negative number."
    );
    return;
  }

  setSavingPdfMarksId(document.id);
  setActionError("");

  try {
    const response = await updateQuestionDocument(
      document.id,
      {
        marks_per_question: value,
      }
    );

    const responseData = response?.data || {};

    // The successful PATCH confirms the save.
    // Keep the submitted value in the UI even if
    // the response contains an older marks value.
    const updated = normalizeDocument({
      ...document,
      ...responseData,
      id: document.id,
      marks_per_question: value,
      marksPerQuestion: value,
    });

    setDocuments((previous) =>
      previous.map((item) =>
        String(item.id) === String(document.id)
          ? updated
          : item
      )
    );

    setPdfMarksDrafts((previous) => ({
      ...previous,
      [document.id]: String(value),
    }));
  } catch (err) {
    setActionError(
      apiErrorMessage(
        err,
        "Could not save marks for this PDF."
      )
    );
  } finally {
    setSavingPdfMarksId(null);
  }
}

  /* =========================================================
     PDF upload
     ========================================================= */

  function openUploadDialog() {
    if (!section?.id) {
      setActionError(
        "Please select a valid exam section first."
      );
      return;
    }

    setUploadTitle("");
    uploadInputRef.current?.click();
  }

  
async function handlePdfSelected(event) {
  const file = event.target.files?.[0];
  event.target.value = "";

  if (!file) return;

  if (
    file.type !== "application/pdf" &&
    !file.name.toLowerCase().endsWith(".pdf")
  ) {
    setActionError("Please select a PDF file.");
    return;
  }

  if (!section?.id) {
    setActionError("No section is selected.");
    return;
  }

  const defaultTitle = file.name.replace(/\.pdf$/i, "");
  const title = window.prompt(
    "Enter a title for this PDF:",
    defaultTitle
  );

  if (title === null) return;

  setUploading(true);
  setActionError("");

  try {
    await uploadQuestionBankPdf({
      sectionId: section.id,
      title: title.trim() || defaultTitle,
      file,
    });

    // Refresh questions and PDF documents after successful upload.
    await loadQuestionBank(section.id);

    const response = await getSections(selectedExamId);
    const sectionData = Array.isArray(response.data)
      ? response.data
      : response.data?.results || response.data?.data || [];

    setSections(sectionData);
  } catch (err) {
    // The backend may save the PDF record even if parsing fails.
    try {
      await loadQuestionBank(section.id);
    } catch (reloadError) {
      console.error(
        "Failed to reload question bank after upload:",
        reloadError
      );
    }

    setActionError(
      apiErrorMessage(
        err,
        "Could not upload and process the PDF."
      )
    );
  } finally {
    setUploading(false);
  }
}

  /* =========================================================
     Save section settings
     ========================================================= */

    
  
async function handleSaveSection() {
  if (!section?.id) return;

  if (!sectionName.trim()) {
    setActionError("Section name is required.");
    return;
  }

  const marksValue = Number(marksPerQuestion);
  const questionCountValue = Number(sectionQuestionCount);
  const durationValue = Number(duration);

  if (
    marksPerQuestion === "" ||
    !Number.isFinite(marksValue) ||
    marksValue < 0
  ) {
    setActionError(
      "Marks per question must be a valid non-negative number."
    );
    return;
  }

  if (
    sectionQuestionCount === "" ||
    !Number.isInteger(questionCountValue) ||
    questionCountValue < 1
  ) {
    setActionError(
      "Question count must be a whole number greater than 0."
    );
    return;
  }

  if (
    duration === "" ||
    !Number.isFinite(durationValue) ||
    durationValue < 1
  ) {
    setActionError("Duration must be at least 1 minute.");
    return;
  }

  let qualificationValueNumber = null;

  if (qualificationType !== "NONE") {
    qualificationValueNumber = Number(qualificationValue);

    if (
      qualificationValue === "" ||
      !Number.isFinite(qualificationValueNumber) ||
      qualificationValueNumber < 0
    ) {
      setActionError(
        "Enter a valid qualification value for the selected qualification rule."
      );
      return;
    }
  }

  setSavingSection(true);
  setActionError("");

  try {
    // Save common section configuration first.
    await updateSection(section.id, {
      name: sectionName.trim(),
      type:
        section.section_type ||
        section.sectionType ||
        section.type,
      questions: questionCountValue,
      marks: marksValue,
      durationMinutes: durationValue,
      sectionOrder: Number(
        section.sectionOrder ??
        section.section_order ??
        1
      ),
      qualificationType,
      qualificationValue: qualificationValueNumber,
      examId: selectedExamId,
    });

    // Apply common marks to every PDF in this section.
    await Promise.all(
      documents.map((document) =>
        updateQuestionDocument(document.id, {
          marks_per_question: marksValue,
        })
      )
    );

    // Refresh section configuration from Django.
    const response = await getSections(selectedExamId);

    const data = Array.isArray(response.data)
      ? response.data
      : response.data?.results ||
        response.data?.data ||
        [];

    setSections(data);

    const updatedSection = data.find(
      (item) => String(item.id) === String(section.id)
    );

    if (updatedSection) {
      setSectionName(updatedSection.name || "");

      setMarksPerQuestion(
        String(
          updatedSection.marks ??
          updatedSection.marksPerQuestion ??
          updatedSection.marks_per_question ??
          marksValue
        )
      );

      setDuration(
        String(
          updatedSection.durationMinutes ??
          updatedSection.duration_minutes ??
          durationValue
        )
      );

      setSectionQuestionCount(
        String(
          updatedSection.questions ??
          updatedSection.questionCount ??
          updatedSection.question_count ??
          questionCountValue
        )
      );

      setQualificationType(
        updatedSection.qualificationType ??
        updatedSection.qualification_type ??
        "NONE"
      );

      setQualificationValue(
        updatedSection.qualificationValue ??
        updatedSection.qualification_value ??
        ""
      );
    }

    // Reload saved PDF marks and allocations.
    await loadQuestionBank(section.id);
  } catch (err) {
    setActionError(
      apiErrorMessage(
        err,
        "Could not save section settings or apply common PDF marks."
      )
    );
  } finally {
    setSavingSection(false);
  }
}

  

  /* =========================================================
     Pagination
     ========================================================= */

  function getPages() {
    const pages = [];

    const end = Math.min(
      5,
      totalPages
    );

    for (
      let index = 1;
      index <= end;
      index += 1
    ) {
      pages.push(index);
    }

    if (totalPages > end) {
      pages.push("ellipsis");
      pages.push(totalPages);
    }

    return pages;
  }

  /* =========================================================
     Render
     ========================================================= */

  return (
    <div className="admin-page-full d-flex">
      <AdminSidebar />

      <div className="admin-content">
        <AdminTopbar
          notificationCount={3}
        />

        {/* Header */}
        <div className="d-flex justify-content-between align-items-start flex-wrap gap-2 mb-3">
          <div>
            <h1 className="h3 fw-bold mb-1">
              Question Bank
              {currentExam
                ? ` - ${currentExam.name}`
                : ""}
            </h1>

            <p className="text-muted mb-0">
              Manage questions for each
              section. Upload PDFs, view
              questions, and configure section
              settings.
            </p>
          </div>

          <div className="d-flex align-items-center gap-2">
            {exams.length > 1 && (
              <select
                className="form-select"
                value={selectedExamId}
                onChange={(event) => {
                  setSelectedExamId(
                    event.target.value
                  );
                  setPage(1);
                }}
                style={{
                  minWidth: 190,
                }}
              >
                {exams.map((exam) => (
                  <option
                    key={exam.id}
                    value={exam.id}
                  >
                    {exam.name}
                  </option>
                ))}
              </select>
            )}

            <button
              type="button"
              className="btn btn-outline-secondary d-inline-flex align-items-center gap-2"
              onClick={() =>
                window.history.back()
              }
            >
              <i className="bi bi-arrow-left" />
              Back to Exam
            </button>
          </div>
        </div>

        {/* Error */}
        {(error || actionError) && (
          <div
            className="alert alert-danger d-flex align-items-start gap-2"
            role="alert"
          >
            <i className="bi bi-exclamation-triangle mt-1" />

            <div className="flex-grow-1">
              {actionError || error}
            </div>

            <button
              type="button"
              className="btn-close"
              onClick={() => {
                setError("");
                setActionError("");
              }}
            />
          </div>
        )}

        {loading ? (
          <div className="admin-card p-5 text-center">
            <div
              className="spinner-border text-primary"
              role="status"
            />

            <div className="text-muted mt-3">
              Loading Question Bank...
            </div>
          </div>
        ) : (
          <>
            {/* Summary */}
            <div className="admin-card qb-summary-card p-3 p-md-4 mb-3">
              <div className="d-flex flex-wrap align-items-center gap-4">
                <div className="d-flex align-items-center gap-3 qb-summary-main">
                  <div className="qb-summary-icon">
                    <i className="bi bi-journal-check" />
                  </div>

                  <div>
                    <div className="d-flex align-items-center gap-2 mb-1">
                      <h2 className="h5 fw-bold mb-0">
                        {currentExam?.name ||
                          "Question Bank"}
                      </h2>

                      <StatusPill
                        status={
                          currentExam?.status ||
                          "Active"
                        }
                      />
                    </div>

                    <div className="qb-meta-row text-muted small">
                      <span>
                        Course:{" "}
                        {currentExam?.courseName ||
                          currentExam?.course ||
                          "—"}
                      </span>

                      <span className="qb-meta-sep">
                        |
                      </span>

                      <span>
                        Exam Fee:{" "}
                        {currentExam?.fee != null
                          ? `₹${Number(
                              currentExam.fee
                            ).toLocaleString(
                              "en-IN"
                            )}`
                          : "—"}
                      </span>

                      <span className="qb-meta-sep">
                        |
                      </span>

                      <span>
                        Result Release Delay:{" "}
                        {currentExam
                          ?.resultDelayHours !=
                        null
                          ? `${currentExam.resultDelayHours} Hours`
                          : "—"}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="d-flex flex-wrap gap-4 ms-lg-auto qb-summary-stats">
                  <div className="qb-mini-stat">
                    <div className="qb-mini-icon blue">
                      <i className="bi bi-cloud-arrow-up-fill" />
                    </div>

                    <div>
                      <div className="qb-mini-value">
                        {totalConfiguredQuestions.toLocaleString()}
                      </div>

                      <div className="qb-mini-label">
                        Total Questions
                      </div>
                    </div>
                  </div>

                  <div className="qb-mini-stat">
                    <div className="qb-mini-icon purple">
                      <i className="bi bi-text-left" />
                    </div>

                    <div>
                      <div className="qb-mini-value">
                        {mcqQuestionCount.toLocaleString()}
                      </div>

                      <div className="qb-mini-label">
                        MCQ Questions
                      </div>
                    </div>
                  </div>

                  <div className="qb-mini-stat">
                    <div className="qb-mini-icon orange">
                      <i className="bi bi-file-earmark-text" />
                    </div>

                    <div>
                      <div className="qb-mini-value">
                        {essayQuestionCount.toLocaleString()}
                      </div>

                      <div className="qb-mini-label">
                        Essay Questions
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Only EA Parts 1–3 use inter-section breaks. */}
            {isEaPart && (
              <div className="admin-card p-3 p-md-4 mb-3">
                <div className="row g-3 align-items-end">
                  <div className="col-12 col-md-6">
                    <h3 className="h6 fw-bold mb-1">Inter-section Break Configuration</h3>
                    <p className="text-muted small mb-0">Configure the break duration between EA sections. Set this to 10 minutes for the three EA parts.</p>
                  </div>
                  <div className="col-7 col-md-3">
                    <label className="form-label">Break Duration (minutes)</label>
                    <input type="number" min="0" step="1" className="form-control" value={breakDurationDraft} onChange={(event) => setBreakDurationDraft(event.target.value)} />
                  </div>
                  <div className="col-5 col-md-3">
                    <button type="button" className="btn btn-primary w-100" onClick={handleSaveBreakDuration} disabled={savingBreakDuration || !selectedExamId}>
                      {savingBreakDuration ? "Saving..." : "Save Break"}
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Tabs */}
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
              <div className="qb-tabs d-flex flex-wrap gap-2">
                {sections.map((item) => {
                  const itemType = getSectionType(item);
                  const itemCount = Number(item.questions || 0);

                  return (
                    <button
                      key={item.id}
                      type="button"
                      className={`qb-tab-btn ${
                        String(activeSectionId) === String(item.id)
                          ? "active"
                          : ""
                      }`}
                      onClick={() => switchTab(item.id)}
                    >
                      {item.name || (itemType === "essay" ? "Essay Section" : "MCQ Section")}
                      {" "}
                      ({itemCount.toLocaleString("en-IN")})
                    </button>
                  );
                })}
              </div>

              <div className="d-flex flex-wrap gap-2">
                <button
                  type="button"
                  className="btn btn-primary d-inline-flex align-items-center gap-2"
                  onClick={() => setCreateSectionOpen((value) => !value)}
                  disabled={!selectedExamId}
                >
                  <i className="bi bi-plus-lg" />
                  Add Section
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary d-inline-flex align-items-center gap-2"
                  onClick={() => setConfigOpen((value) => !value)}
                >
                  <i className="bi bi-gear" />
                  Section Settings
                </button>
              </div>
            </div>

            {createSectionOpen && (
              <div className="admin-card p-3 p-md-4 mb-3">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h3 className="h6 fw-bold mb-0">Create Exam Section</h3>
                  <button type="button" className="btn-close" aria-label="Close" onClick={() => setCreateSectionOpen(false)} />
                </div>
                <div className="row g-3">
                  <div className="col-12 col-md-4">
                    <label className="form-label">Section Name *</label>
                    <input className="form-control" value={newSection.name} onChange={(e) => setNewSection((p) => ({ ...p, name: e.target.value }))} placeholder="e.g. Section 1 / Essay" />
                  </div>
                  <div className="col-6 col-md-2">
                    <label className="form-label">Question Type *</label>
                    <select className="form-select" value={newSection.type} onChange={(e) => setNewSection((p) => ({ ...p, type: e.target.value, qualificationType: e.target.value === "ESSAY" ? "NONE" : p.qualificationType }))}>
                      <option value="MCQ">MCQ</option>
                      <option value="ESSAY">Essay</option>
                    </select>
                  </div>
                  <div className="col-6 col-md-2">
                    <label className="form-label">Questions *</label>
                    <input type="number" min="1" step="1" className="form-control" value={newSection.questions} onChange={(e) => setNewSection((p) => ({ ...p, questions: e.target.value }))} />
                  </div>
                  <div className="col-6 col-md-2">
                    <label className="form-label">Marks / Question</label>
                    <input type="number" min="0" step="any" className="form-control" value={newSection.marks} onChange={(e) => setNewSection((p) => ({ ...p, marks: e.target.value }))} />
                  </div>
                  <div className="col-6 col-md-2">
                    <label className="form-label">Duration (min) *</label>
                    <input type="number" min="1" step="1" className="form-control" value={newSection.durationMinutes} onChange={(e) => setNewSection((p) => ({ ...p, durationMinutes: e.target.value }))} />
                  </div>
                  <div className="col-6 col-md-2">
                    <label className="form-label">Section Order *</label>
                    <input type="number" min="1" step="1" className="form-control" value={newSection.sectionOrder} placeholder={String(sections.length + 1)} onChange={(e) => setNewSection((p) => ({ ...p, sectionOrder: e.target.value }))} />
                  </div>
                  <div className="col-6 col-md-3">
                    <label className="form-label">Qualification Rule</label>
                    <select className="form-select" value={newSection.qualificationType} onChange={(e) => setNewSection((p) => ({ ...p, qualificationType: e.target.value, qualificationValue: e.target.value === "NONE" ? "" : p.qualificationValue }))}>
                      <option value="NONE">No qualification</option>
                      <option value="CORRECT_ANSWERS">Minimum correct answers</option>
                      <option value="SCORE">Minimum score</option>
                      <option value="PERCENTAGE">Minimum percentage</option>
                    </select>
                  </div>
                  {newSection.qualificationType !== "NONE" && (
                    <div className="col-6 col-md-3">
                      <label className="form-label">Qualification Value</label>
                      <input type="number" min="0" step="1" className="form-control" value={newSection.qualificationValue} onChange={(e) => setNewSection((p) => ({ ...p, qualificationValue: e.target.value }))} />
                    </div>
                  )}
                  <div className="col-12 d-flex justify-content-end gap-2">
                    <button type="button" className="btn btn-outline-secondary" onClick={() => setCreateSectionOpen(false)} disabled={creatingSection}>Cancel</button>
                    <button type="button" className="btn btn-primary" onClick={handleCreateSection} disabled={creatingSection}>{creatingSection ? "Creating..." : "Create Section"}</button>
                  </div>
                </div>
                <small className="text-muted d-block mt-3">This creates a section for the currently selected exam. Existing sections and their questions are not changed.</small>
              </div>
            )}

            {!section ? (
              <div className="admin-card p-5 text-center">
                <i className="bi bi-folder-x fs-1 text-muted" />

                <h4 className="h6 fw-bold mt-3">
                  No {activeSectionTypeLabel} section found
                </h4>

                <p className="text-muted mb-0">
                  Create this section from
                  the Sections admin page
                  before managing its questions.
                </p>
              </div>
            ) : (
              <div className="row g-3 align-items-stretch">
                {/* Main content */}
                <div
                  className={
                    configOpen
                      ? "col-12 col-xl-8"
                      : "col-12"
                  }
                >
                  <div className="admin-card p-3 p-md-4 h-100 d-flex flex-column">
                    {/* Section header */}
                    <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                      <div className="d-flex align-items-center gap-2">
                        <div
                          className="qb-summary-icon"
                          style={{
                            width: 40,
                            height: 40,
                            fontSize:
                              "1.05rem",
                            background:
                              "var(--oes-blue)",
                          }}
                        >
                          <i className="bi bi-text-left" />
                        </div>

                        <div>
                          <div className="d-flex align-items-center gap-2">
                            <h3 className="h6 fw-bold mb-0">
                              {section.name}
                            </h3>

                            <StatusPill status="Active" />
                          </div>

                          <div className="qb-meta-row text-muted small">
                            <span>
                              Marks per Question:{" "}
                              {section.marks ??
                                "—"}
                            </span>

                            <span className="qb-meta-sep">
                              |
                            </span>

                            <span>
                              Total Questions:{" "}
                              {totalQuestionCount.toLocaleString()}
                            </span>

                            <span className="qb-meta-sep">
                              |
                            </span>

                            <span>
                              PDF Files:{" "}
                              {documents.length}
                            </span>

                            <span className="qb-meta-sep">
                              |
                            </span>

                            <span>
                              Duration:{" "}
                              {section.durationMinutes ??
                                "—"}{" "}
                              minutes
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="d-flex gap-2">
                        <button
                          type="button"
                          className="btn btn-outline-primary btn-sm d-inline-flex align-items-center gap-2"
                          onClick={() =>
                            setConfigOpen(true)
                          }
                        >
                          <i className="bi bi-pencil" />
                          Edit Section
                        </button>
                      </div>
                    </div>

                    {/* PDF files */}
                    <div className="mb-4">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <h4 className="h6 fw-bold mb-0">
                          PDF Files (
                          {activeSectionTypeLabel}
                          )
                        </h4>

                        <button
                          type="button"
                          className="btn btn-primary btn-sm d-inline-flex align-items-center gap-2"
                          onClick={
                            openUploadDialog
                          }
                          disabled={uploading}
                        >
                          <i className="bi bi-plus-lg" />

                          {uploading
                            ? "Uploading..."
                            : `Upload ${activeSectionTypeLabel} PDF`}
                        </button>

                        <input
                          ref={
                            uploadInputRef
                          }
                          type="file"
                          accept="application/pdf,.pdf"
                          className="d-none"
                          onChange={
                            handlePdfSelected
                          }
                        />
                      </div>

                      <div className="table-responsive">
                        <table className="table admin-table align-middle mb-0">
                          <thead>
                            <tr>
                              <th
                                style={{
                                  width: 32,
                                }}
                              >
                                #
                              </th>

                              <th
                                style={{
                                  width: 32,
                                }}
                              >
                                <input
                                  type="checkbox"
                                  disabled={
                                    documents.length ===
                                    0
                                  }
                                />
                              </th>

                              <th>
                                File Name
                              </th>

                              <th>
                                Uploaded On
                              </th>

                              <th>
                                Questions Extracted
                              </th>

                              <th>
                                Questions per Attempt
                              </th>

                              <th>
                                Total Questions
                              </th>

                              <th>
                                Marks per Question
                              </th>

                              <th>
                                Total Marks
                              </th>

                              <th>
                                Status
                              </th>

                              <th>
                                Actions
                              </th>
                            </tr>
                          </thead>

                          <tbody>
                            {documentsLoading ? (
                              <tr>
                                <td
                                  colSpan={11}
                                  className="text-center py-4"
                                >
                                  <div
                                    className="spinner-border spinner-border-sm text-primary"
                                    role="status"
                                  />
                                </td>
                              </tr>
                            ) : documents.length ===
                              0 ? (
                              <tr>
                                <td
                                  colSpan={11}
                                  className="text-center text-muted py-4"
                                >
                                  No PDF files uploaded
                                  for this section.
                                </td>
                              </tr>
                            ) : (
                              documents.map(
                                (
                                  document,
                                  index
                                ) => (
                                  <tr
                                    key={
                                      document.id
                                    }
                                  >
                                    <td>
                                      {index +
                                        1}
                                    </td>

                                    <td>
                                      <input
                                        type="checkbox"
                                      />
                                    </td>

                                    <td className="fw-semibold">
                                      {document.name}
                                    </td>

                                    <td>
                                      {
                                        document.uploadedOn
                                      }
                                    </td>

                                    <td>
                                      {document.extracted.toLocaleString()}
                                    </td>

                                    <td style={{ minWidth: 180 }}>
                                      <div className="d-flex align-items-center gap-2">
                                        <input
                                          type="number"
                                          min="0"
                                          max={document.extracted}
                                          className="form-control form-control-sm"
                                          style={{ width: 82 }}
                                          aria-label={`Questions to select from ${document.name}`}
                                          value={
                                            pdfAllocationDrafts[document.id] ??
                                            String(document.selectionCount ?? 0)
                                          }
                                          onChange={(event) =>
                                            setPdfAllocationDrafts((previous) => ({
                                              ...previous,
                                              [document.id]: event.target.value,
                                            }))
                                          }
                                        />
                                        <button
                                          type="button"
                                          className="btn btn-outline-primary btn-sm"
                                          onClick={() => handleSavePdfAllocation(document)}
                                          disabled={savingPdfAllocationId === document.id}
                                        >
                                          {savingPdfAllocationId === document.id
                                            ? "Saving..."
                                            : "Save"}
                                        </button>
                                      </div>
                                      <small className="text-muted d-block mt-1">
                                        randomly selected per attempt from {document.extracted} extracted
                                      </small>
                                    </td>

                                    <td className="fw-semibold">
                                      {(() => {
                                        const count = Number(
                                          pdfAllocationDrafts[document.id] ??
                                          document.selectionCount ??
                                          0
                                        );
                                        return (Number.isFinite(count) && count > 0 ? count : 0).toLocaleString("en-IN");
                                      })()}
                                    </td>

                                    <td style={{ minWidth: 180 }}>
                                      <div className="d-flex align-items-center gap-2">
                                        <input
                                          type="number"
                                          min="0"
                                          step="any"
                                          className="form-control form-control-sm"
                                          style={{ width: 82 }}
                                          aria-label={`Marks per question for ${document.name}`}
                                          value={
                                            pdfMarksDrafts[document.id] ??
                                            String(document.marksPerQuestion ?? 0)
                                          }
                                          onChange={(event) =>
                                            setPdfMarksDrafts((previous) => ({
                                              ...previous,
                                              [document.id]: event.target.value,
                                            }))
                                          }
                                        />
                                        <button
                                          type="button"
                                          className="btn btn-outline-primary btn-sm"
                                          onClick={() => handleSavePdfMarks(document)}
                                          disabled={savingPdfMarksId === document.id}
                                        >
                                          {savingPdfMarksId === document.id
                                            ? "Saving..."
                                            : "Save"}
                                        </button>
                                      </div>
                                      <small className="text-muted d-block mt-1">
                                        Marks per question
                                      </small>
                                    </td>

                                    <td className="fw-semibold">
                                      {(
                                        Math.max(
                                          0,
                                          Number(
                                            pdfAllocationDrafts[document.id] ??
                                            document.selectionCount ??
                                            0
                                          ) || 0
                                        ) *
                                        Math.max(
                                          0,
                                          Number(
                                            pdfMarksDrafts[document.id] ??
                                            document.marksPerQuestion ??
                                            0
                                          ) || 0
                                        )
                                      ).toLocaleString("en-IN", {
                                        maximumFractionDigits: 2,
                                      })}
                                    </td>

                                    <td>
                                      <StatusPill
                                        status={
                                          document.status ===
                                          "COMPLETED"
                                            ? "Completed"
                                            : document.status
                                        }
                                      />
                                    </td>

                                    <td>
                                      <div className="d-flex gap-2">
                                        {document.pdfFile && (
                                          <IconBtn
                                            variant="primary"
                                            icon="bi-eye"
                                            onClick={() =>
                                              window.open(
                                                document.pdfFile,
                                                "_blank",
                                                "noopener,noreferrer"
                                              )
                                            }
                                          >
                                            View
                                          </IconBtn>
                                        )}

                                        <IconBtn
                                          variant="danger"
                                          icon="bi-trash"
                                          onClick={() =>
                                            handleDeleteDocument(
                                              document
                                            )
                                          }
                                        >
                                          Delete
                                        </IconBtn>
                                      </div>
                                    </td>
                                  </tr>
                                )
                              )
                            )}
                          </tbody>
                        </table>
                      </div>

                      <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 border rounded p-3 mt-3 bg-light">
                        <div>
                          <div className="fw-semibold">Configured PDF total</div>
                          <small className="text-muted">
                            Based on the current question-count and marks-per-question values.
                          </small>
                        </div>
                        <div className="text-end">
                          <div className="small text-muted">Questions per attempt</div>
                          <div className="fw-bold">
                            {documents.reduce((total, document) => {
                              const count = Number(
                                pdfAllocationDrafts[document.id] ??
                                document.selectionCount ??
                                0
                              );
                              return total + (Number.isFinite(count) && count > 0 ? count : 0);
                            }, 0).toLocaleString("en-IN")}
                          </div>
                        </div>
                        <div className="text-end">
                          <div className="small text-muted">Total possible marks</div>
                          <div className="fw-bold">
                            {documents.reduce((total, document) => {
                              const count = Number(
                                pdfAllocationDrafts[document.id] ??
                                document.selectionCount ??
                                0
                              );
                              const marks = Number(
                                pdfMarksDrafts[document.id] ??
                                document.marksPerQuestion ??
                                0
                              );
                              if (!Number.isFinite(count) || !Number.isFinite(marks)) return total;
                              return total + Math.max(0, count) * Math.max(0, marks);
                            }, 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Questions */}
                    <div className="flex-grow-1 d-flex flex-column">
                      <h4 className="h6 fw-bold mb-2">
                        Questions (
                        {activeSectionTypeLabel}
                        )
                      </h4>

                      <div className="d-flex flex-wrap gap-2 mb-3 qb-filters-row">
                        <div
                          className="position-relative flex-grow-1"
                          style={{
                            minWidth: 220,
                          }}
                        >
                          <i
                            className="bi bi-search position-absolute"
                            style={{
                              left: 12,
                              top: "50%",
                              transform:
                                "translateY(-50%)",
                              color:
                                "var(--oes-text-muted)",
                            }}
                          />

                          <input
                            type="text"
                            className="form-control ps-4"
                            placeholder="Search questions..."
                            value={search}
                            onChange={(
                              event
                            ) => {
                              setSearch(
                                event.target
                                  .value
                              );
                              setPage(1);
                            }}
                          />
                        </div>

                        <select
                          className="form-select"
                          style={{
                            maxWidth: 160,
                          }}
                          value={chapter}
                          onChange={(
                            event
                          ) => {
                            setChapter(
                              event.target
                                .value
                            );
                            setPage(1);
                          }}
                          disabled={
                            chapters.length <=
                            1
                          }
                        >
                          {chapters.map(
                            (value) => (
                              <option
                                key={value}
                                value={value}
                              >
                                {value}
                              </option>
                            )
                          )}
                        </select>

                        <select
                          className="form-select"
                          style={{
                            maxWidth: 140,
                          }}
                          value={status}
                          onChange={(
                            event
                          ) => {
                            setStatus(
                              event.target
                                .value
                            );
                            setPage(1);
                          }}
                        >
                          <option value="All">
                            All
                          </option>

                          <option value="Active">
                            Active
                          </option>

                          <option value="Inactive">
                            Inactive
                          </option>
                        </select>

                        <button
                          type="button"
                          className="btn btn-outline-secondary d-inline-flex align-items-center gap-2"
                          onClick={
                            resetFilters
                          }
                        >
                          <i className="bi bi-arrow-counterclockwise" />
                          Reset
                        </button>

                        <div className="position-relative">
                          <button
                            type="button"
                            className="btn btn-outline-secondary d-inline-flex align-items-center gap-2"
                            onClick={() =>
                              setBulkMenuOpen(
                                (value) =>
                                  !value
                              )
                            }
                            disabled={
                              selectedQuestions.length ===
                              0
                            }
                          >
                            <i className="bi bi-sliders" />
                            Bulk Actions
                          </button>

                          {bulkMenuOpen && (
                            <div className="qb-bulk-menu">
                              <button
                                type="button"
                                onClick={() =>
                                  handleBulkStatus(
                                    true
                                  )
                                }
                              >
                                Mark as Active
                              </button>

                              <button
                                type="button"
                                onClick={() =>
                                  handleBulkStatus(
                                    false
                                  )
                                }
                              >
                                Mark as Inactive
                              </button>

                              <button
                                type="button"
                                className="text-danger"
                                onClick={
                                  handleBulkDelete
                                }
                              >
                                Delete selected
                              </button>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="table-responsive">
                        <table className="table admin-table align-middle mb-0">
                          <thead>
                            <tr>
                              <th
                                style={{
                                  width: 32,
                                }}
                              >
                                #
                              </th>

                              <th
                                style={{
                                  width: 32,
                                }}
                              >
                                <input
                                  type="checkbox"
                                  checked={
                                    visibleQuestions.length >
                                      0 &&
                                    visibleQuestions.every(
                                      (
                                        question
                                      ) =>
                                        selectedQuestions.includes(
                                          question.id
                                        )
                                    )
                                  }
                                  onChange={
                                    toggleAllQuestions
                                  }
                                  disabled={
                                    visibleQuestions.length ===
                                    0
                                  }
                                />
                              </th>

                              <th>
                                Question
                              </th>

                              <th>
                                Chapter
                              </th>

                              <th>
                                Status
                              </th>

                              <th>
                                Actions
                              </th>
                            </tr>
                          </thead>

                          <tbody>
                            {questionsLoading ? (
                              <tr>
                                <td
                                  colSpan={6}
                                  className="text-center py-5"
                                >
                                  <div
                                    className="spinner-border text-primary"
                                    role="status"
                                  />

                                  <div className="text-muted mt-2">
                                    Loading questions...
                                  </div>
                                </td>
                              </tr>
                            ) : visibleQuestions.length ===
                              0 ? (
                              <tr>
                                <td
                                  colSpan={6}
                                  className="text-center text-muted py-5"
                                >
                                  No questions match
                                  your filters.
                                </td>
                              </tr>
                            ) : (
                              visibleQuestions.map(
                                (
                                  question,
                                  index
                                ) => (
                                  <tr
                                    key={
                                      question.id
                                    }
                                  >
                                    <td>
                                      {(page -
                                        1) *
                                        PAGE_SIZE +
                                        index +
                                        1}
                                    </td>

                                    <td>
                                      <input
                                        type="checkbox"
                                        checked={selectedQuestions.includes(
                                          question.id
                                        )}
                                        onChange={() =>
                                          toggleQuestion(
                                            question.id
                                          )
                                        }
                                      />
                                    </td>

                                    <td>
                                      {question.text ||
                                        "—"}
                                    </td>

                                    <td>
                                      {question.chapter ||
                                        "—"}
                                    </td>

                                    <td>
                                      <StatusPill
                                        status={
                                          question.status
                                        }
                                      />
                                    </td>

                                    <td>
                                      <div className="d-flex gap-2 flex-wrap">
                                        <IconBtn
                                          variant="primary"
                                          icon={
                                            question.status ===
                                            "Active"
                                              ? "bi-pause-circle"
                                              : "bi-check-circle"
                                          }
                                          onClick={() =>
                                            handleToggleQuestionStatus(
                                              question
                                            )
                                          }
                                        >
                                          {question.status ===
                                          "Active"
                                            ? "Inactive"
                                            : "Active"}
                                        </IconBtn>

                                        <IconBtn
                                          variant="danger"
                                          icon="bi-trash"
                                          onClick={() =>
                                            handleDeleteQuestion(
                                              question
                                            )
                                          }
                                        >
                                          Delete
                                        </IconBtn>
                                      </div>
                                    </td>
                                  </tr>
                                )
                              )
                            )}
                          </tbody>
                        </table>
                      </div>

                      <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mt-3">
                        <small className="text-muted">
                          Showing {startIdx} to{" "}
                          {endIdx} of{" "}
                          {filteredQuestions.length.toLocaleString()}{" "}
                          filtered questions
                        </small>

                        <nav>
                          <ul className="pagination mb-0">
                            <li
                              className={`page-item ${
                                page === 1
                                  ? "disabled"
                                  : ""
                              }`}
                            >
                              <button
                                className="page-link"
                                onClick={() =>
                                  setPage(
                                    (
                                      value
                                    ) =>
                                      Math.max(
                                        1,
                                        value -
                                          1
                                      )
                                  )
                                }
                              >
                                <i className="bi bi-chevron-left" />
                              </button>
                            </li>

                            {getPages().map(
                              (
                                pageNumber,
                                index
                              ) =>
                                pageNumber ===
                                "ellipsis" ? (
                                  <li
                                    key={`ellipsis-${index}`}
                                    className="page-item disabled"
                                  >
                                    <span className="page-link">
                                      …
                                    </span>
                                  </li>
                                ) : (
                                  <li
                                    key={
                                      pageNumber
                                    }
                                    className={`page-item ${
                                      page ===
                                      pageNumber
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    <button
                                      className="page-link"
                                      onClick={() =>
                                        setPage(
                                          pageNumber
                                        )
                                      }
                                    >
                                      {
                                        pageNumber
                                      }
                                    </button>
                                  </li>
                                )
                            )}

                            <li
                              className={`page-item ${
                                page ===
                                totalPages
                                  ? "disabled"
                                  : ""
                              }`}
                            >
                              <button
                                className="page-link"
                                onClick={() =>
                                  setPage(
                                    (
                                      value
                                    ) =>
                                      Math.min(
                                        totalPages,
                                        value +
                                          1
                                      )
                                  )
                                }
                              >
                                <i className="bi bi-chevron-right" />
                              </button>
                            </li>
                          </ul>
                        </nav>
                      </div>

                      <div className="d-flex align-items-center gap-3 flex-wrap mt-3">
                        <button
                          type="button"
                          className="btn btn-outline-danger d-inline-flex align-items-center gap-2"
                          onClick={
                            handleDeleteAllQuestions
                          }
                          disabled={
                            questions.length ===
                            0
                          }
                        >
                          <i className="bi bi-trash" />

                          Delete All{" "}
                          {activeSectionTypeLabel}{" "}
                          Questions
                        </button>

                        <div className="alert alert-danger py-2 px-3 mb-0 small flex-grow-1 d-flex align-items-center gap-2">
                          <i className="bi bi-exclamation-triangle" />

                          This permanently
                          deletes all questions
                          in this section. PDF
                          files will not be
                          deleted.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right configuration */}
                {configOpen && (
                  <div className="col-12 col-xl-4">
                    <div className="d-flex flex-column gap-3 h-100">
                      <div className="admin-card p-3 p-md-4">
                        <h3 className="h6 fw-bold mb-3 d-flex align-items-center gap-2">
                          <i className="bi bi-gear" />

                          Section Configuration (
                          {activeSectionTypeLabel}
                          )
                        </h3>

                        <div className="mb-3">
                          <label className="form-label">
                            Section Name
                          </label>

                          <input
                            type="text"
                            className="form-control"
                            value={
                              sectionName
                            }
                            onChange={(
                              event
                            ) =>
                              setSectionName(
                                event.target
                                  .value
                              )
                            }
                          />
                        </div>

                        <div className="row g-3 mb-3">
                          <div className="col-6">
                            <label className="form-label">Question Count</label>
                            <input type="number" min="1" step="1" className="form-control" value={sectionQuestionCount} onChange={(event) => setSectionQuestionCount(event.target.value)} />
                          </div>
                          <div className="col-6">
                            <label className="form-label">Section Order</label>
                            <input type="number" className="form-control" value={section.sectionOrder ?? section.section_order ?? 1} disabled readOnly />
                          </div>
                        </div>

                        <div className="row g-3 mb-3">
                          <div className="col-12">
                            <label className="form-label">Qualification Rule</label>
                            <select className="form-select" value={qualificationType} onChange={(event) => { setQualificationType(event.target.value); if (event.target.value === "NONE") setQualificationValue(""); }}>
                              <option value="NONE">No qualification</option>
                              <option value="CORRECT_ANSWERS">Minimum correct answers</option>
                              <option value="SCORE">Minimum score</option>
                              <option value="PERCENTAGE">Minimum percentage</option>
                            </select>
                          </div>
                          {qualificationType !== "NONE" && (
                            <div className="col-12">
                              <label className="form-label">Qualification Value</label>
                              <input type="number" min="0" step="1" className="form-control" value={qualificationValue} onChange={(event) => setQualificationValue(event.target.value)} />
                            </div>
                          )}
                        </div>

                        <div className="row g-3 mb-1">
                          <div className="col-7">
                            <label className="form-label">
                              Question Type
                            </label>

                            <select
                              className="form-select"
                              disabled
                              value={activeSectionTypeLabel}
                              onChange={() => {}}
                            >
                              <option>{activeSectionTypeLongLabel}</option>
                            </select>
                          </div>

                          <div className="col-5">
                            <label className="form-label">
                              Marks per Question{" "}
                              <span className="text-danger">
                                *
                              </span>
                            </label>

                            <input
                              type="number"
                              min="0"
                              className="form-control"
                              value={
                                marksPerQuestion
                              }
                              onChange={(
                                event
                              ) =>
                                setMarksPerQuestion(
                                  event.target
                                    .value
                                )
                              }
                            />
                          </div>
                        </div>

                        <small className="text-muted d-block mb-3">
                          This value is stored in
                          the exam section
                          configuration.
                        </small>

                        <div className="row g-3 mb-4">
                          <div className="col-7">
                            <label className="form-label">
                              Duration (Minutes)
                            </label>

                            <input
                              type="number"
                              min="1"
                              className="form-control"
                              value={
                                duration
                              }
                              onChange={(
                                event
                              ) =>
                                setDuration(
                                  event.target
                                    .value
                                )
                              }
                            />
                          </div>

                          <div className="col-5">
                            <label className="form-label">
                              Status
                            </label>

                            <input
                              type="text"
                              className="form-control"
                              value="Configured"
                              disabled
                              readOnly
                            />
                          </div>
                        </div>

                        <div className="d-flex justify-content-end gap-2">
                          <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={() => {
                              setSectionName(
                                section.name ||
                                  ""
                              );
                              setMarksPerQuestion(
                                section.marks ??
                                  ""
                              );
                              setDuration(
                                section.durationMinutes ?? section.duration_minutes ?? ""
                              );
                              setSectionQuestionCount(section.questions ?? section.questionCount ?? section.question_count ?? "");
                              setQualificationType(section.qualificationType ?? section.qualification_type ?? "NONE");
                              setQualificationValue(section.qualificationValue ?? section.qualification_value ?? "");
                              setActionError(
                                ""
                              );
                            }}
                          >
                            Cancel
                          </button>

                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={
                              handleSaveSection
                            }
                            disabled={
                              savingSection
                            }
                          >
                            {savingSection
                              ? "Saving..."
                              : "Save Changes"}
                          </button>
                        </div>
                      </div>

                      <div className="qb-notes-box">
                        <h4 className="h6 fw-bold mb-2 d-flex align-items-center gap-2">
                          <i className="bi bi-info-circle" />

                          Important Notes
                        </h4>

                        <ul>
                          <li>
                            MCQ and Essay
                            questions are managed
                            separately.
                          </li>

                          <li>
                            Marks and duration are
                            stored in the section
                            configuration.
                          </li>

                          <li>
                            You can upload multiple
                            PDFs through the existing
                            question parser.
                          </li>

                          <li>
                            Removing a PDF deactivates
                            its questions for future
                            exam selection. Historical
                            attempts are retained.
                          </li>

                          <li>
                            Questions can be deleted
                            individually or in bulk.
                          </li>
                        </ul>
                      </div>

                      <div className="admin-card p-3 p-md-4">
                        <h4 className="h6 fw-bold mb-3 d-flex align-items-center gap-2 text-success">
                          <i className="bi bi-check-circle" />

                          Section Actions
                        </h4>

                        <div className="qb-action-row">
                          <div className="d-flex align-items-center gap-2">
                            <button
                              type="button"
                              className="qb-btn-soft-primary btn d-inline-flex align-items-center gap-2"
                              onClick={
                                openUploadDialog
                              }
                              disabled={
                                uploading
                              }
                            >
                              <i className="bi bi-cloud-arrow-up" />

                              {uploading
                                ? "Uploading..."
                                : `Upload More ${activeSectionTypeLabel} PDF`}
                            </button>
                          </div>

                          <small className="text-muted">
                            Add more questions
                            through the existing
                            PDF parser.
                          </small>
                        </div>

                        <div className="qb-action-row">
                          <button
                            type="button"
                            className="qb-btn-soft-danger btn d-inline-flex align-items-center gap-2"
                            onClick={
                              handleDeleteAllQuestions
                            }
                            disabled={
                              questions.length ===
                              0
                            }
                          >
                            <i className="bi bi-trash" />

                            Delete All{" "}
                            {activeSectionTypeLabel}{" "}
                            Questions
                          </button>

                          <small className="text-muted">
                            Permanently delete
                            all questions in
                            this section.
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
